require("trade_selector/trade_search");
require("bijou/smart_form");
require("bijou/smart_form/masking");
require("bijou/jquery.mask");
require("bijou/widgets/info_box_set");

const requireSmartForm = require.context("./smart_form", true);
requireSmartForm.keys().forEach(requireSmartForm);
require("analytics/section_tracker");
require("analytics/tracking_result");
require("ci5/modules/business_name_check");
require("ci5/date-of-birth-question-mapping");
require("ci5/chat_widget_events");
require("ci5/focus_first_question");
require("ci5/consolidated-questions.js");


import { plValidationNotRequired } from "ci5/pl_validation_not_required";
import { loqateAddressAutocomplete } from "ci5/loqate_address";
import {
  toggleDynamicSecondaryText,
  toggleConsolidatedQuestionsGroup,
} from "./consolidated-questions";
import {
  addressFieldsAnsweredValidation,
  loqateApiErrorValidation,
} from "ci5/loqate_address/error_handling";
import {
  setupRebuildCostInputEvents,
  updateBackofficeThirdPartyDataInfo,
  updateRebuildCostInputState,
  isThirdPartyRebuildCostView,
} from "ci5/smart_form/third_party_data";

const contactDetailFields = [
  "first_name",
  "last_name",
  "email_address",
  "telephone_number",
];

function businessQuestionnaire() {
  return $("body").hasClass("business");
}
function shopQuestionnaire() {
  return $("body").hasClass("shop");
}
function landlordQuestionnaire() {
  return $("body").hasClass("landlord");
}
function professionalQuestionnaire() {
  return $("body").hasClass("professional");
}
function backofficeQuestionnaire() {
  return $("body").hasClass("backoffice");
}

function coverageSelectionQuestionnaire() {
  return $("body").data("journey-name") === "coverage_selection";
}

function usaQuestionnaire() {
  return $("body").hasClass("usa");
}

function shouldValidateConsolidatedQuestions(){
  return $("body").hasClass("site-simplybusiness_us") && !$("body").hasClass("business_owners_policy")
}

function workersCompensationQuestionnaire() {
  return $("body").hasClass("workers_compensation");
}

function businessOwnersPolicyQuestionnaire() {
  return $("body").hasClass("business_owners_policy");
}

function isBusinessUnitUS() {
  return $("body").hasClass("business_unit_simplybusiness_us");
}

function isUsSite(){
  return $("body").hasClass("site-simplybusiness_us")
}

function isEligibleForUpdatedSecondaryText() {
  return usaQuestionnaire();
}

function professionalBusiness() {
  return professionalQuestionnaire() || businessQuestionnaire();
}

function clericalEmployeesPresent() {
  return businessQuestionnaire() && $("#clerical_employees").length > 0;
}

function clericalDirectorsPresent() {
  return businessQuestionnaire() && $("#clerical_directors").length > 0;
}

function clericalPartnersPresent() {
  return businessQuestionnaire() && $("#clerical_partners").length > 0;
}

function validateSubcontractorPayroll() {
  return (
    usaQuestionnaire() &&
    $("#subcontractor_payroll").length > 0 &&
    $("#subcontractor_payroll").data("validate-against-revenue") == true
  );
}

function sofWarehouseStockAmountPresent() {
  return shopQuestionnaire() && $("#sof_warehouse_stock_amount").length > 0;
}

function formatMoney(value) {
  const currency = "£";
  return currency + Math.abs(Number(value)) / 1.0e6 + "m";
}

function totalEmployeesPresent() {
  return (
    businessQuestionnaire() &&
    ($("#total_employees_ex_temp").length > 0 ||
      $("#total_employees_or_losc").length > 0)
  );
}

function ernNumberPartValid(value, pattern) {
  const cleanedValue = value.replace(/\s/gi, "");
  return cleanedValue.match(pattern) !== null;
}

function taxOfficeCodeProvided() {
  return !!$("#employer_reference_number_tax_office_code").val();
}

function disclosuresPresent() {
  return $("#disclosures").length > 0;
}

function taxOfficeEmployerReferenceProvided() {
  return !!$("#employer_reference_number_tax_office_employer_reference").val();
}

function usaNewBusiness() {
  const journeyName = $("body").data("journey-name");

  return (
    journeyName === "usa" ||
    journeyName === "backoffice_new_business" ||
    journeyName === "amend_async"
  );
}

function stringToInt(value) {
  return value && parseInt(value.replace(/,/g, ""), 10);
}

function ownerPayrollAndEmployeePayrollFilled() {
  return !!$("#owner_payroll").val() && !!$("#employee_payroll").val();
}

function workersCompensationEmployeeCountEqualsOwnerCount() {
  return $("#employee_count").val() == "0";
}

function ownerPayrollXFilled(x) {
  return !!$(`#owner_payroll_${x}`).val();
}

function totalOwnerPayroll() {
  let totalOwnerPayroll = stringToInt($("#owner_payroll").val());
  let ownerIndex = 2;
  while (ownerIndex <= stringToInt($("#owner_count").val())) {
    if (ownerPayrollXFilled(ownerIndex)) {
      totalOwnerPayroll =
        totalOwnerPayroll +
        stringToInt($(`#owner_payroll_${ownerIndex}`).val());
      ownerIndex++;
    } else {
      break;
    }
  }
  return totalOwnerPayroll;
}

function updateEmployeePayrollSecondaryText() {
  if (!isEligibleForUpdatedSecondaryText()) {
    return;
  }
  if ($("#employee_count").val() == "0" || $("#employee_count").val() == '') {
    $("#employee_payroll_secondary_label").html(
        "Please enter your yearly net income as your payroll. Please note the payroll may be adjusted to meet carrier state requirements.");
  } else if (parseInt($("#employee_count").val(), 10) >= 1) {
    //  This is the secondary text that is on the question in rater. I wonder if we swapped the logic, if this function could be simplified.
    $("#employee_payroll_secondary_label").html(
      `Estimate the total amount that you will pay over the next 12 months for:
      <br>
      <ul>
        <li> Yourself </li>
        <li> Full-time employees </li>
        <li> Part-time employees </li>
        <li> Temporary employees (W2) </li>
      </ul>
      Do not include subcontractors (1099). Please note the payroll may be adjusted to meet state requirements.`
    );
  }
}

function updateOwnerPayrollSecondaryText() {
  if (!isEligibleForUpdatedSecondaryText()) {
    return;
  }

  //  This is the secondary text that is on the question in rater. I wonder if we can remove this function.
  $("#owner_payroll_secondary_label").html("This is the total compensation you estimate owners will receive. If you're a sole owner, enter your yearly net income if you don't take a salary."
  );
}

function ownerPayroll() {
  // When the employee count equals the employee count, the owner payroll is the same as the employee payroll
  // so we rely on other validation.
  if (workersCompensationQuestionnaire()) {
    if (workersCompensationEmployeeCountEqualsOwnerCount()) {
      return false;
    }
  }
  return (
    (usaQuestionnaire() || workersCompensationQuestionnaire()) &&
    ownerPayrollAndEmployeePayrollFilled()
  );
}

function ownerPayrollAndEmployeeCountEqualsOwnersCount() {
  if (workersCompensationQuestionnaire()) {
    return (
      workersCompensationEmployeeCountEqualsOwnerCount() &&
      ownerPayrollAndEmployeePayrollFilled()
    );
  }
  return (
    usaNewBusiness() &&
    ownerPayrollAndEmployeePayrollFilled()
  );
}

function ownershipPercentageXFilled(owner_number) {
  return owner_number == 1
    ? !!$("#ownership_percentage").val()
    : !!$(`#ownership_percentage_${owner_number}`).val();
}

function numberOfOwnersOnPage4() {
  let numOwners = 5;
  while (numOwners > 0) {
    if ($(`#ownership_percentage_${numOwners}`).length == 1) {
      return numOwners;
      break;
    }
    numOwners--;
  }
}

function allOwnershipPercentagesFilled() {
  let ownerCount = numberOfOwnersOnPage4();
  let ownerNumber = 1;
  while (ownerNumber <= ownerCount) {
    if (ownershipPercentageXFilled(ownerNumber)) {
      ownerNumber++;
    } else {
      return false;
    }
  }
  return true;
}

function totalOwnershipPercentage() {
  let totalOwnershipPercentage = stringToInt($("#ownership_percentage").val());
  let ownerIndex = 2;
  while (ownerIndex <= numberOfOwnersOnPage4()) {
    if (ownershipPercentageXFilled(ownerIndex)) {
      totalOwnershipPercentage =
        totalOwnershipPercentage +
        stringToInt($(`#ownership_percentage_${ownerIndex}`).val());
      ownerIndex++;
    } else {
      break;
    }
  }
  return totalOwnershipPercentage;
}

function usaPlCoverSelection() {
  return (
    usaQuestionnaire() &&
    $("input[name=include_professional_liability]").length > 0 &&
    $("input[name=include_workers_compensation]:visible").length == 0
  );
}

function usaGlCoverSelection() {
  return (
    usaQuestionnaire() &&
    $("input[name=include_general_liability]").length > 0 &&
    $("input[name=include_workers_compensation]:visible").length == 0
  );
}

function usaWCCoverSelection() {
  return (
    usaQuestionnaire() &&
    $("input[name=include_workers_compensation]:visible").length > 0
  );
}

function displayAjaxErrorMessage(changedElement) {
  const ajaxErrorMessage =
    "It looks like you might have our site open in \
  multiple tabs or windows, or experienced a network connection problem. \
  You can continue your purchase in the other window, or refresh this page.";

  const parent = $(changedElement).closest(".control");
  parent.siblings(".error").remove();
  $(
    `<label class="error" id="qa-ajax-error" role="alert" aria-atomic="true">${ajaxErrorMessage}</label>`,
  ).insertAfter(parent);
}

function displayPayrollMessage(changedElement, action) {
  const payrollMessage =
    "Employee payroll amount cannot be $0. To provide you the most accurate quote, please ensure payroll is accurately allocated between the owners and employees.";
  const parent = $(changedElement).closest(".control");
  parent.siblings(".error").remove();

  if (action == "insertAfter")
    $(
      `<label class="error" id="payroll-error" role="alert" aria-atomic="true">${payrollMessage}</label>`,
    ).insertAfter(parent);
  else
    $(
      `<label class="error" id="payroll-error" role="alert" aria-atomic="true">${payrollMessage}</label>`,
    ).remove();
}

//////////////////////// Request COI on payment confirmation page //////////////////

const coiModalSuccess = $('.js-coi-modal-success')
const coiModalFailure = $('.js-coi-modal-failure')

const closeCoiModalsElements = $('.js-coi-close-btn-success, .js-coi-close-btn-failure, .js-coi-close-icon')

closeCoiModalsElements.on("click", function (e) {
  coiModalSuccess.hide()
  coiModalFailure.hide()
})

const coiRequestBtn = $(".js-coi-request-btn")

coiRequestBtn.on("click", function (e) {
  e.preventDefault()
  e.stopImmediatePropagation();

  const loadingCoiBtn = $('.js-coi-request-btn-loading')

  $.ajax({
    type: "POST",
    url: `${location.pathname}?step_action=email_certificates_of_insurance`,
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    },
    data: {},
    dataType: "json"
  })
    .done(function (data) {
      if (data.success) {
        coiModalSuccess.show()
      } else {
        coiModalFailure.show()
      }
    })
    .fail(function (_jqXHR, textStatus) {
      coiModalFailure.show()
    })
    .always(function () {
      loadingCoiBtn.hide()
      coiRequestBtn.show()
    })

  coiRequestBtn.hide()
  loadingCoiBtn.show()
});

//////////////////////// Request COI on payment confirmation page //////////////////

(function ($) {
  $.widget("chopin.smart_form", $.bijou.smart_form, {
    options: {
      helpTriggerHtml:
        "<button class='help-trigger info-box-toggle' aria-label='Help' aria-expanded='false'><span>Help</span></button>",
      openHelpTriggerText: "<span>Help</span>",
      closedHelpTriggerText: "<span>Close Help</span>",
      showHelpAutoOnBreakpoint: "desktop",
      animateHelp: false,
      customValidation: {
        errorElement: "span",
        ignore: ".validator-ignore, :hidden",
        rules: {
          uk_postcode: {},
          "own_plant[1][value]": {
            validate_own_plant_value: true,
          },
          "own_plant[2][value]": {
            validate_own_plant_value: true,
          },
          "own_plant[3][value]": {
            validate_own_plant_value: true,
          },
          "own_plant[4][value]": {
            validate_own_plant_value: true,
          },
          "own_plant[5][value]": {
            validate_own_plant_value: true,
          },
          own_plant_sum_insured: {
            validate_own_plant_sum_insured: true,
          },
          "customer[confirm_contact_details][]":{
            required: true,
          },
          professional_indemnity_required: {
            required: true,
          },
          uk_postcode_pre_quote: {
            required: true,
          },
          same_correspondence_address: {
            required: true,
          },
          buyer_first_name: {
            required: true,
            validate_not_duplicated_details: true,
          },
          buyer_last_name: {
            required: true,
            validate_not_duplicated_details: true,
          },
          buyer_telephone_number: {
            required: true,
            validate_not_duplicated_details: true,
          },
          buyer_email_address: {
            required: true,
            validate_not_duplicated_details: true,
          },
          "buyer_authority_confirmation[]": {
            required: true,
          },
          "customer[external_customer_reference]": {
            validate_clear_business_customer_reference: true,
          },
          consolidated_contractor: {
            required: true,
            validate_consolidated_questions_answered: true,
          },

          consolidated_accounting: {
            required: true,
            validate_consolidated_questions_answered: true,
          },

          business_owner: {
            required: true,
          },

          consolidated_research_consulting: {
            required: true,
            validate_consolidated_questions_answered: true,
          },

          consolidated_refrigeration_repair: {
            required: true,
            validate_consolidated_questions_answered: true,
          },

          consolidated_previous_claims: {
            required: true,
            validate_consolidated_yes_no_questions_answered: true,
          },

          us_zipcode: {
            validate_us_zipcode: true,
          },
          primary_and_noncontributory_test: {
            validate_primary_and_noncontributory: true
          },
          none_of_the_above: {
            validate_at_least_one_answered: { depends: shouldValidateConsolidatedQuestions }
          },
          additional_insured: {
            validate_at_least_one_answered: { depends: shouldValidateConsolidatedQuestions },
          },
          waiver_of_subrogation: {
            validate_at_least_one_answered: { depends: shouldValidateConsolidatedQuestions }
          },
          us_state: {
            required: () => !coverageSelectionQuestionnaire(),
            eligible_wc_state: { depends: workersCompensationQuestionnaire },
          },
          mailing_us_zipcode: {
            validate_mailing_us_zipcode: true,
          },
          pl_cover_limit: {
            validate_landlord_cover_options: { depends: landlordQuestionnaire },
            validate_pl_limit_amount: { depends: professionalBusiness },
            validate_not_required: { depends: professionalBusiness },
            not: {
              param: "0", // Not Required
              depends(element) {
                return (
                  $("#el_cover_limit").prop("selectedIndex") > 1 ||
                  ((element.id == "optional_public_liability" ||
                    element.id == "public_liability") &&
                    $("#professional_indemnity").val() == "0") ||
                  (element.id == "public_liability" &&
                    $(
                      "#tenants_improvements_or_buildings_Neither_cover_is_required",
                    ).is(":checked") &&
                    $("#include_contents_Don_t_include_this_cover").is(
                      ":checked",
                    ))
                );
              },
            },
          },
          pi_cover_limit: {
            not: {
              param: "0",
              depends() {
                return (
                  ($("#optional_public_liability").val() == "0" ||
                    $("#public_liability").val() == "0") &&
                  $("#professional_indemnity").val() == "0"
                );
              },
            },
          },
          include_professional_liability: {
            validate_us_all_cover: { depends: usaWCCoverSelection },
            validate_us_pl_cover: { depends: usaPlCoverSelection },
          },
          include_general_liability: {
            validate_us_all_cover: { depends: usaWCCoverSelection },
            validate_us_gl_cover: { depends: usaGlCoverSelection },
          },
          include_workers_compensation: {
            validate_us_wc_cover: { depends: usaWCCoverSelection },
            validate_us_all_cover: { depends: usaWCCoverSelection },
          },
          "disclosures[]": {
            validate_disclosures: { depends: disclosuresPresent },
          },
          "employer_reference_number[tax_office_code]": {
            validate_tax_office_code: { depends: taxOfficeCodeProvided },
          },
          "employer_reference_number[tax_office_employer_reference]": {
            validate_tax_office_employer_reference: {
              depends: taxOfficeEmployerReferenceProvided,
            },
          },
          owner_payroll: {
            validate_owner_employee_payroll: { depends: ownerPayroll },
            validate_owner_payroll_not_equal_employee_payroll: {
              depends: ownerPayroll,
            },
          },
          owner_payroll_2: {
            validate_owner_employee_payroll: { depends: ownerPayroll },
            validate_owner_payroll_not_equal_employee_payroll: {
              depends: ownerPayroll,
            },
          },
          owner_payroll_3: {
            validate_owner_employee_payroll: { depends: ownerPayroll },
            validate_owner_payroll_not_equal_employee_payroll: {
              depends: ownerPayroll,
            },
          },
          owner_payroll_4: {
            validate_owner_employee_payroll: { depends: ownerPayroll },
            validate_owner_payroll_not_equal_employee_payroll: {
              depends: ownerPayroll,
            },
          },
          owner_payroll_5: {
            validate_owner_employee_payroll: { depends: ownerPayroll },
            validate_owner_payroll_not_equal_employee_payroll: {
              depends: ownerPayroll,
            },
          },
          employee_payroll: {
            validate_total_payroll_owner_payroll: {
              depends: workersCompensationQuestionnaire,
            },
          },
          ownership_percentage: {
            validate_ownership_percentage_total: {
              depends: allOwnershipPercentagesFilled,
            },
          },
          ownership_percentage_2: {
            validate_ownership_percentage_total: {
              depends: allOwnershipPercentagesFilled,
            },
          },
          ownership_percentage_3: {
            validate_ownership_percentage_total: {
              depends: allOwnershipPercentagesFilled,
            },
          },
          ownership_percentage_4: {
            validate_ownership_percentage_total: {
              depends: allOwnershipPercentagesFilled,
            },
          },
          ownership_percentage_5: {
            validate_ownership_percentage_total: {
              depends: allOwnershipPercentagesFilled,
            },
          },
          clerical_partners: {
            must_be_an_integer: { depends: clericalPartnersPresent },
            less_than_total_partners: { depends: clericalPartnersPresent },
          },
          clerical_directors: {
            must_be_an_integer: { depends: clericalDirectorsPresent },
            less_than_total_directors: { depends: clericalDirectorsPresent },
          },
          clerical_employees: {
            must_be_an_integer: { depends: clericalEmployeesPresent },
            less_than_total_employees: { depends: clericalEmployeesPresent },
          },
          total_directors: {
            must_be_an_integer: { depends: clericalDirectorsPresent },
            no_manual_workers_directors: { depends: clericalDirectorsPresent },
          },
          sof_warehouse_stock_amount: {
            less_than_stock_cover: { depends: sofWarehouseStockAmountPresent },
            no_stock_cover_selected: {
              depends: sofWarehouseStockAmountPresent,
            },
          },
          delayed_fein: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            fein_must_not_be_invalid: {
              depends: workersCompensationQuestionnaire,
            },
          },
          delayed_ssn: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            ssn_must_not_be_invalid: {
              depends: workersCompensationQuestionnaire,
            },
          },
          ssn: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            ssn_must_not_be_invalid: {
              depends: workersCompensationQuestionnaire,
            },
          },
          ssn_2: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            ssn_must_not_be_invalid: {
              depends: workersCompensationQuestionnaire,
            },
          },
          ssn_3: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            ssn_must_not_be_invalid: {
              depends: workersCompensationQuestionnaire,
            },
          },
          ssn_4: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            ssn_must_not_be_invalid: {
              depends: workersCompensationQuestionnaire,
            },
          },
          ssn_5: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            ssn_must_not_be_invalid: {
              depends: workersCompensationQuestionnaire,
            },
          },
          fein: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            fein_must_not_be_invalid: {
              depends: workersCompensationQuestionnaire,
            },
          },
          total_employees: {
            must_be_an_integer: { depends: totalEmployeesPresent },
          },
          california_contractor_license: {
            contains_three_to_eight_digits: {
              depends: workersCompensationQuestionnaire,
            },
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
          },
          hawaii_unemployment_insurance_number: {
            hawaii_unemployment_validation: { depends: workersCompensationQuestionnaire },
          },
          minnesota_unemployment: {
            contains_eight_digits: {
              depends: workersCompensationQuestionnaire,
            },
          },
          rhode_island_unemployment: {
            contains_ten_digits: { depends: workersCompensationQuestionnaire },
          },
          maine_unemployment: {
            contains_ten_digits: { depends: workersCompensationQuestionnaire },
          },
          oregon_unemployment: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
          },
          colorado_unemployment: {
            contains_eight_to_fifteen_digits: {
              depends: workersCompensationQuestionnaire,
            },
          },
          iowa_unemployment: {
            contains_eight_to_fifteen_digits: {
              depends: workersCompensationQuestionnaire,
            },
          },
          utah_unemployment: {
            contains_nine_digits: { depends: workersCompensationQuestionnaire },
          },
          owner_count: {
            from_two_to_five: { depends: workersCompensationQuestionnaire }
          },
          weight_of_item: {
            must_be_an_integer: { depends: workersCompensationQuestionnaire },
            added_maximum_value: { depends: workersCompensationQuestionnaire },
          },
          total_partners: {
            must_be_an_integer: { depends: clericalPartnersPresent },
            no_manual_workers_partners: { depends: clericalPartnersPresent },
          },
          subcontractor_payroll: {
            less_than_annual_revenue: { depends: validateSubcontractorPayroll },
          },
          value_of_business_personal_property_input: {
            validate_bpp_value: { depends: businessOwnersPolicyQuestionnaire },
          },
          tenants_improvements_or_buildings: {
            required: true,
            min: {
              param: 0,
              depends() {
                return (
                  $("#public_liability").val() == 0 &&
                  $("#include_contents_Don_t_include_this_cover").is(
                    ":checked",
                  ) &&
                  $(
                    "#tenants_improvements_or_buildings_Neither_cover_is_required",
                  ).is(":checked")
                );
              },
            },
          },
          trade_selector: {
            trade_must_be_selected: true,
            ai_trade_must_be_selected: true,
            ai_trade_must_be_selected_with_options: true,
          },
          address_autocomplete: {
            address_fields_must_be_answered: true,
            loqate_api_error: true,
          },
          include_contents: {
            required: true,
            min: {
              param: 0,
              depends() {
                return (
                  $("#public_liability").val() == 0 &&
                  $("#include_contents_Don_t_include_this_cover").is(
                    ":checked",
                  ) &&
                  $(
                    "#tenants_improvements_or_buildings_Neither_cover_is_required",
                  ).is(":checked")
                );
              },
            },
          },
          legal_expenses_sum_insured: {
            required: true,
          },
          additional_covers: {
            required: true,
          },
          buildings_sum_insured: {
            validate_buildings_sum_insured_range_inclusion: true,
          },
          business_personal_property_limit: {
            required: true,
          },
          computer_hardware_or_software_limit: {
            required: true,
          },
          limit_selection_photography_and_videography_equipment: {
            required: true,
          },
          value_of_equipment_inland_marine: {
            required: true,
          },
          inland_marine_limit: {
            required: true,
          },
          inland_marine_deductible: {
            required: true,
          },
          equipment_used_for_operations_inland_marine: {
            required: true,
          },
          nuclear_work_inland_marine: {
            required: true,
          },
          loss_payee_inland_marine: {
            required: true,
          },
          tpd_confirmation: {
            required: true,
          },
          excess_sum_insured: {
            required: true,
          },
          tenant_default_sum_insured: {
            required: true,
          },
          home_emergency_cover_selected: {
            required: true,
          },
          consolidated_consulting_ineligible_operations: {
            required: true,
          },
          contractors_small_tools_limit: {
            required: true,
          },
          consolidated_safety_consulting_ineligible_industries: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_safety_consulting_ineligible_services: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_insurance_professionals_products: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_insurance_professionals_agency: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_health_and_wellbeing: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_sales: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_software_development: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_training_ineligible_services: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_ae_work_on_projects: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_ae_perform_physical_services: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_restaurant_operations_or_services: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_restaurant_product_categories: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_hardware_store_ineligible_products: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_convenience_store_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_variety_stores_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_auto: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_drugstore_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_mailbox_store_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_music_store_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_art_store_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_shoe_stores_ineligible_products: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_camera_store_ineligible_products: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_electrical_work_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_personal_concierge_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_health_aides_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_personal_training_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_mobile_food_services_ineligible_products: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_onsite_food_services_ineligible_operations: {
         required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_marketing_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_marketing_ineligible_operations_professional_liability_or_both: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_retail_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_educational_consulting_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_event_planner_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_snow_removal_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_commercial_photography_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_retail_ineligible_operations_bouncy_house: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_small_engine_repair_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_fence_installation_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_entertainer_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_musician_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_appliance_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_plumbing_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_concrete_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_cooking_training_ineligible_services: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_trucking_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_mobile_food_ineligibles: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_jewelry_making_manufacturing_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_car_detailing_ineligible_ops: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_human_resources_consulting_ineligible_operations: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_product_details: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          consolidated_pay_subcontractors_1099_workers: {
            required: true,
            validate_consolidated_questions_answered: true,
          },
          year_built: {
            bop_input_year_valid: {
              depends: businessOwnersPolicyQuestionnaire,
            },
          },
          roofing_improvement_year: {
            bop_input_year_valid: {
              depends: businessOwnersPolicyQuestionnaire,
            },
          },
          heating_year: {
            contains_four_digits: {
              depends: businessOwnersPolicyQuestionnaire,
            },
          },
          plumbing_year: {
            contains_four_digits: {
              depends: businessOwnersPolicyQuestionnaire,
            },
          },
          wiring_year: {
            contains_four_digits: {
              depends: businessOwnersPolicyQuestionnaire,
            },
          },
        },

        groups: {
          sort_code: "sort_code[1] sort_code[2] sort_code[3]",
          additional_insured_group: "additional_insured waiver_of_subrogation none_of_the_above"
        },

        messages: {
          "customer[external_customer_reference]": {
            validate_clear_business_customer_reference: "This customer ID is not valid."
          },
          consolidated_contractor: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },
          consolidated_accounting: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_refrigeration_repair: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_research_consulting: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_insurance_professionals_products: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_health_and_wellbeing: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_insurance_professionals_agency: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_sales: {
            required: true,
            validate_consolidated_questions_answered:
            "Please select an option below",
          },

          consolidated_software_development: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_training_ineligible_services: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_ae_perform_physical_services: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_ae_work_on_projects: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_previous_claims: {
            validate_consolidated_yes_no_questions_answered:
              "Selecting ‘Yes’ indicates that one or more of the questions below apply to your business. Please mark the applicable question(s) as ‘Yes.’",
          },

          consolidated_restaurant_operations_or_services: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_restaurant_product_categories: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_hardware_store_ineligible_products: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_convenience_store_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_variety_stores_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_auto: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_drugstore_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_mailbox_store_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_music_store_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_art_store_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_shoe_stores_ineligible_products: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_camera_store_ineligible_products: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_electrical_work_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_marketing_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_small_engine_repair_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_trucking_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_personal_concierge_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_marketing_ineligible_operations_professional_liability_or_both: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_fence_installation_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_mobile_food_ineligibles: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_health_aides_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_retail_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_entertainer_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_jewelry_making_manufacturing_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_personal_training_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_educational_consulting_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_musician_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_car_detailing_ineligible_ops: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_appliance_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_plumbing_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_mobile_food_services_ineligible_products: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_event_planner_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_concrete_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_snow_removal_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_onsite_food_services_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_commercial_photography_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_retail_ineligible_operations_bouncy_house: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_cooking_training_ineligible_services: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_human_resources_consulting_ineligible_operations: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_pay_subcontractors_1099_workers: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          consolidated_product_details: {
            validate_consolidated_questions_answered:
              "Please select an option below",
          },

          uk_postcode: {
            uk_postcode_default:
              'Enter a UK postcode, or <a href="https://www.simplybusiness.co.uk/support/" target="_blank">contact us</a> for help',
          },
          "own_plant[1][value]": {
            validate_own_plant_value:
              "The amount entered for this individual item cannot be greater than the total cost of replacing all your own plant machinery",
          },
          "own_plant[2][value]": {
            validate_own_plant_value:
              "The amount entered for this individual item cannot be greater than the total cost of replacing all your own plant machinery",
          },
          "own_plant[3][value]": {
            validate_own_plant_value:
              "The amount entered for this individual item cannot be greater than the total cost of replacing all your own plant machinery",
          },
          "own_plant[4][value]": {
            validate_own_plant_value:
              "The amount entered for this individual item cannot be greater than the total cost of replacing all your own plant machinery",
          },
          "own_plant[5][value]": {
            validate_own_plant_value:
              "The amount entered for this individual item cannot be greater than the total cost of replacing all your own plant machinery",
          },
          own_plant_sum_insured: {
            validate_own_plant_sum_insured:
              "The amount entered for your individual own plant items cannot be greater than the total cost of replacing all your own plant machinery",
          },
          professional_indemnity_required: {
            required:
              'Select whether Professional Indemnity insurance is required, or <a href="https://www.simplybusiness.co.uk/support/" target="_blank">contact us</a> for help',
          },
          us_zipcode: {
            validate_us_zipcode: function () {
              const stateName = $("#us_zipcode").attr(
                "data-zip-code-validation-state-name",
              );
              return `Looks like that zip code is not in ${stateName}. Try updating your zip code.`;
            },
          },
          mailing_us_zipcode: {
            validate_mailing_us_zipcode: function () {
              const mailingStateName = $("#mailing_us_zipcode").attr(
                "mailing-data-zip-code-validation-state-name",
              );
              return `Looks like the mailing zip code is not in ${mailingStateName}. Try updating your zip code.`;
            },
          },
          pl_cover_limit: {
            not(index, element) {
              if (
                element.id == "optional_public_liability" ||
                element.id == "public_liability"
              ) {
                if (
                  $(
                    "#tenants_improvements_or_buildings_Neither_cover_is_required",
                  ).length == 0
                ) {
                  return "Your policy must include public liability insurance, professional indemnity insurance or both. Please choose at least one of these covers to continue.";
                } else {
                  return "Your policy must include public liability insurance, tenants' improvements or buildings insurance, contents insurance or all of them. Please choose at least one of these covers to continue.";
                }
              }
              if (
                element.id == "optional_public_liability" ||
                (element.id == "public_liability" &&
                  $(
                    "#tenants_improvements_or_buildings_Neither_cover_is_required",
                  ).is(":checked") == true)
              ) {
                return "Your policy must include public liability insurance, professional indemnity insurance or both. Please choose at least one of these covers to continue.";
              }
              return "Employers' liability must be purchased with Public liability.";
            },
            validate_landlord_cover_options:
              "Unfortunately we do not offer property owners' liability on its own. Please select buildings, contents or fixtures & fittings",
            validate_pl_limit_amount: function () {
              const plLimit = $("#optional_public_liability").length > 0 ? formatMoney($("#optional_public_liability").attr("data-pl-limit")) : formatMoney($("#public_liability").attr("data-pl-limit"));
              const coverName = $(".questionnaire").find("[data-question='public_liability'] .control-text label").text();
              const phoneNumber = $("#optional_public_liability").length > 0 ? $("#optional_public_liability").data("contact-phone-number") : $("#public_liability").data("contact-phone-number");

              return `At this time we are only able to provide policies with <b>up to ${plLimit} in ${coverName} cover</b>. If you have any questions please call us on <b>${phoneNumber}</b>`
            },
            validate_not_required: `Your policy must include public liability insurance`,
          },
          pi_cover_limit: {
            not: "Your policy must include public liability insurance, professional indemnity insurance or both. Please choose at least one of these covers to continue.",
          },
          total_employees: {
            must_be_an_integer: "Please enter a number eg 2",
          },
          "employer_reference_number[tax_office_code]": {
            validate_tax_office_code:
              "The first part of your ERN will be made up of 3 numbers.",
          },
          "employer_reference_number[tax_office_employer_reference]": {
            validate_tax_office_employer_reference:
              "The second part of your ERN will be made up of 1-2 letters, followed by up to 6 numbers.",
          },
          include_professional_liability: {
            validate_us_pl_cover:
              "Your policy must include general liability, professional liability or both. Please choose at least one of these products to continue.",
            validate_us_all_cover:
              "It appears you have not selected a coverage. To continue, please select a coverage or call us at <a href='tel:+8446547272'>(844) 654-7272</a> to speak to one of our agents.",
          },
          include_general_liability: {
            validate_us_gl_cover:
              "Your policy must include general liability, professional liability or both. Please choose at least one of these products to continue.",
            validate_us_all_cover:
              "It appears you have not selected a coverage. To continue, please select a coverage or call us at <a href='tel:+8446547272'>(844) 654-7272</a> to speak to one of our agents.",
          },
          include_workers_compensation: {
            validate_us_wc_cover:
              "If you would like Workers Compensation only, please click on the link below.",
            validate_us_all_cover:
              "It appears you have not selected a coverage. To continue, please select a coverage or call us at <a href='tel:+8446547272'>(844) 654-7272</a> to speak to one of our agents.",
          },
          us_state: {
            eligible_wc_state:
              "Private workers' compensation insurance is not available in this state. Please look to your state's workers' compensation fund to seek coverage.",
          },
          delayed_ssn: {
            contains_nine_digits: "Valid SSN contains 9 digits.",
            must_be_an_integer: "Must input valid characters into SSN field.",
            ssn_must_not_be_invalid: "Invalid SSN.",
          },
          ssn: {
            contains_nine_digits: "Valid SSN contains 9 digits.",
            must_be_an_integer: "Must input valid characters into SSN field.",
            ssn_must_not_be_invalid: "Invalid SSN.",
          },
          ssn_2: {
            contains_nine_digits: "Valid SSN contains 9 digits.",
            must_be_an_integer: "Must input valid characters into SSN field.",
            ssn_must_not_be_invalid: "Invalid SSN.",
          },
          ssn_3: {
            contains_nine_digits: "Valid SSN contains 9 digits.",
            must_be_an_integer: "Must input valid characters into SSN field.",
            ssn_must_not_be_invalid: "Invalid SSN.",
          },
          ssn_4: {
            contains_nine_digits: "Valid SSN contains 9 digits.",
            must_be_an_integer: "Must input valid characters into SSN field.",
            ssn_must_not_be_invalid: "Invalid SSN.",
          },
          ssn_5: {
            contains_nine_digits: "Valid SSN contains 9 digits.",
            must_be_an_integer: "Must input valid characters into SSN field.",
            ssn_must_not_be_invalid: "Invalid SSN.",
          },
          delayed_fein: {
            contains_nine_digits: "Valid EIN contains 9 digits.",
            must_be_an_integer: "Must input valid characters into EIN field.",
            fein_must_not_be_invalid: "Invalid EIN.",
          },
          fein: {
            contains_nine_digits: "Valid EIN contains 9 digits.",
            must_be_an_integer: "Must input valid characters into EIN field.",
            fein_must_not_be_invalid: "Invalid EIN.",
          },
          california_contractor_license: {
            contains_three_to_eight_digits:
              "Valid California Contractor License contains 3 to 8 digits.",
            must_be_an_integer:
              "Must input valid characters into California Contractor's License field.",
          },
          hawaii_unemployment_insurance_number: {
            hawaii_unemployment_validation:  "Hawaii Unemployment Identification Number (UI) has an invalid format. The ID must contain 10 characters. Click the '?' icon to get more information",
          },
          minnesota_unemployment: {
            contains_eight_digits:
              "Minnesota Unemployment Identification Number (UI) is required and must be 8 digits.",
          },
          rhode_island_unemployment: {
            contains_ten_digits:
              "Rhode Island Unemployment Identification Number (UI) is required and must be 10 digits.",
          },
          maine_unemployment: {
            contains_ten_digits:
              "Maine Employer Account Number (EAN) is required and must be 10-digits long.",
          },
          oregon_unemployment: {
            contains_nine_digits:
              "Oregon Tax Identification Number (TIN) is required and must be 9-digits long.",
            must_be_an_integer: "Please only enter numeric values.",
          },
          colorado_unemployment: {
            contains_eight_to_fifteen_digits:
              "Colorado Unemployment Identification Number is required and must be between 8 and 15 digits long.",
          },
          iowa_unemployment: {
            contains_eight_to_fifteen_digits:
              "Iowa Unemployment Identification Number is required and must be between 8 and 15 digits long.",
          },
          utah_unemployment: {
            contains_nine_digits:
              "Utah Unemployment Identification Number is required and must be 9-digits long.",
          },
          owner_count: {
            from_two_to_five: "Partnerships require at least 2 owners.",
          },
          weight_of_item: {
            must_be_an_integer: "Must input numbers only",
            added_maximum_value: "The maximum weight can not exceed 9,999 lbs.",
          },
          owner_payroll: {
            validate_owner_employee_payroll:
              "Please enter a value that is less than the total company payroll.",
            validate_owner_payroll_not_equal_employee_payroll:
              "Please enter a value that is less than the amount you entered for Total Company Payroll. Payrolls cannot match.",
          },
          owner_payroll_2: {
            validate_owner_employee_payroll:
              "Please enter a value that is less than the total company payroll.",
            validate_owner_payroll_not_equal_employee_payroll:
              "Please enter a value that is less than the amount you entered for Total Company Payroll. Payrolls cannot match.",
          },
          owner_payroll_3: {
            validate_owner_employee_payroll:
              "Please enter a value that is less than the total company payroll.",
            validate_owner_payroll_not_equal_employee_payroll:
              "Please enter a value that is less than the amount you entered for Total Company Payroll. Payrolls cannot match.",
          },
          owner_payroll_4: {
            validate_owner_employee_payroll:
              "Please enter a value that is less than the total company payroll.",
            validate_owner_payroll_not_equal_employee_payroll:
              "Please enter a value that is less than the amount you entered for Total Company Payroll. Payrolls cannot match.",
          },
          owner_payroll_5: {
            validate_owner_employee_payroll:
              "Please enter a value that is less than the total company payroll.",
            validate_owner_payroll_not_equal_employee_payroll:
              "Please enter a value that is less than the amount you entered for Total Company Payroll. Payrolls cannot match.",
          },
          ownership_percentage: {
            validate_ownership_percentage_total:
              "The total ownership percentage must add up to 100%",
          },
          ownership_percentage_2: {
            validate_ownership_percentage_total:
              "The total ownership percentage must add up to 100%",
          },
          ownership_percentage_3: {
            validate_ownership_percentage_total:
              "The total ownership percentage must add up to 100%",
          },
          ownership_percentage_4: {
            validate_ownership_percentage_total:
              "The total ownership percentage must add up to 100%",
          },
          ownership_percentage_5: {
            validate_ownership_percentage_total:
              "The total ownership percentage must add up to 100%",
          },
          clerical_partners: {
            must_be_an_integer: "Please enter a number eg 2",
            less_than_total_partners:
              "The number of clerical partners can't be greater than the total number of partners",
          },
          subcontractor_payroll: {
            less_than_annual_revenue:
              "Please enter a value that is less than or equal to the amount you expect your business to earn over the next 12 months.",
          },
          value_of_business_personal_property_input: {
            validate_bpp_value:
              "Your property and equipment is below $250,000, please select correct dollar value from the drop down list above.",
          },
          clerical_directors: {
            must_be_an_integer: "Please enter a number eg 2",
            less_than_total_directors:
              "The number of clerical directors can't be greater than the total number of directors",
          },
          clerical_employees: {
            must_be_an_integer: "Please enter a number eg 2",
            less_than_total_employees:
              "The number of clerical employees can't be greater than the total number of employees",
          },
          total_directors: {
            must_be_an_integer: "Please enter a number eg 2",
            no_manual_workers_directors:
              "For your trade, at least one director or employee must be doing manual work",
          },
          sof_warehouse_stock_amount: {
            less_than_stock_cover:
              "The value selected is greater than the Stock cover limit selected on the Cover Options page. Please enter a value equal to or less than the Stock cover limit. Or you can adjust your Stock cover limit on the previous page.",
            no_stock_cover_selected:
              "Please select the Stock cover on the Cover Options page if you have goods with a monetary value to be insured in the warehouse. Otherwise select No stock.",
          },
          total_partners: {
            must_be_an_integer: "Please enter a number eg 2",
            no_manual_workers_partners:
              "For your trade, at least one partner or employee must be doing manual work",
          },
          tenants_improvements_or_buildings: {
            not(index, element) {
              if (element.id == "tenants_improvements_or_buildings") {
                return true;
              }
            },
          },
          trade_selector: {
            trade_must_be_selected: "Please select a trade from the list",
            ai_trade_must_be_selected: "Please describe your business",
            ai_trade_must_be_selected_with_options: "Please select a trade or refine your description",
          },
          address_autocomplete: {
            address_fields_must_be_answered:
              "Please select your business address or enter it manually.",
            loqate_api_error:
              "We cannot retrieve your address at this time. <span class='enter-manually' role='button'>Please enter your address manually.</span>",
          },
          buyer_first_name: {
            validate_not_duplicated_details:
              "Your contact details cannot be the same as the Policyholder if you are acting on behalf of the policyholder",
          },
          buyer_last_name: {
            validate_not_duplicated_details:
              "Your contact details cannot be the same as the Policyholder if you are acting on behalf of the policyholder",
          },
          buyer_email_address: {
            validate_not_duplicated_details:
              "Your contact details cannot be the same as the Policyholder if you are acting on behalf of the policyholder",
          },
          buyer_telephone_number: {
            validate_not_duplicated_details:
              "Your contact details cannot be the same as the Policyholder if you are acting on behalf of the policyholder",
          },
          buildings_sum_insured: {
            validate_buildings_sum_insured_range_inclusion:
              "The number must be between 20,000 and 100,000,000",
          },
          year_built: {
            bop_input_year_valid: "Please enter a valid year.",
          },
          roofing_improvement_year: {
            bop_input_year_valid: "Please enter a valid year.",
          },
          heating_year: {
            contains_four_digits: "Valid year contains 4 digits.",
          },
          plumbing_year: {
            contains_four_digits: "Valid year contains 4 digits.",
          },
          wiring_year: {
            contains_four_digits: "Valid year contains 4 digits.",
          },
        },
        include_contents: {
          not(index, element) {
            if (element.id == "include_contents") {
              return true;
            }
          },
        },
      },
      resetLabelsOnBreakpoint: true,
    },

    _create() {
      const _this = this;
      this._super();

      this.environment = this.getEnvironmentName();

      if (window.EventTracker) {
        this._on({
          submit: this._trackSubmitted,
        });
      }

      this.element
        .find("[data-section-name='Important documents']")
        .disclosures();
      this.element.find(":checkbox").checkbox();

      const $inlineHelpText = this.element.find(".inline-help-text");
      $inlineHelpText.length > 0 &&
        $inlineHelpText.each(function () {
          $(this)
            .closest(".info-box-content")
            .addClass("inline-help-text-content");
        });

      this.element.find(".claim.control-group").each(function () {
        const $controlGroup = $(this);
        $controlGroup.on("validationchange", function () {
          if ($controlGroup.find(":input").filter(".error").length > 0) {
            $controlGroup.addClass("error");
            $controlGroup.find(".control-block.error").removeClass("error");
          } else {
            $controlGroup.removeClass("error");
          }
        });
      });

      function validateInputType(e, expression) {
        let target = $(e.target);
        let sanitized_input = target.val().replace(expression, "");
        target.val(sanitized_input);

        _this.element.validate().element(`#${e.target.id}`);
      }

      const validateInput = (e) => {
        validateInputType(e, /\D/g);
      };

      const validateAlphaNumInput = (e) => {
        validateInputType(e, /\W/g);
      };

      const validatePercentage = (e) => {
        let target = $(e.target);
        let sanitized_input = parseInt(target.val());
        target.val(sanitized_input);

        _this.element.validate().element(`#${e.target.id}`);
      };

      updateEmployeePayrollSecondaryText();
      updateOwnerPayrollSecondaryText();

      $("#employee_count").on("change", function () {
        updateEmployeePayrollSecondaryText();
        updateOwnerPayrollSecondaryText();
      });

      $("#california_contractor_license, #weight_of_item").on(
        "blur",
        function (e) {
          validateInput(e);
        },
      );

      $("#fein, #delayed_fein").mask("00-0000000", { placeholder: "__-________" });
      $("#ssn, #ssn_2, #ssn_3, #ssn_4, #ssn_5, #delayed_ssn").mask("000-00-0000", {
        placeholder: "___-__-____",
      });

      $("#fein, #ssn, #ssn_2, #ssn_3, #ssn_4, #ssn_5, #delayed_fein, #delayed_ssn").on(
        "keypress",
        function (e) {
          _this.element.validate().element(`#${e.target.id}`);
        },
      );
      $("#fein, #ssn, #ssn_2, #ssn_3, #ssn_4, #ssn_5, #delayed_fein, #delayed_ssn, #new_jersey_unemployment").on("blur", function (e) {
        e.target.type = "password";
      });
      $("#fein, #ssn, #ssn_2, #ssn_3, #ssn_4, #ssn_5, #delayed_fein, #delayed_ssn, #new_jersey_unemployment").on(
        "focus",
        function (e) {
          e.target.type = "text";
        },
      );

      $("#year_built").mask("0000");
      $("#roofing_improvement_year").mask("0000");
      $("#heating_year").mask("0000");
      $("#plumbing_year").mask("0000");
      $("#wiring_year").mask("0000");

      $(
        "#hawaii_unemployment_insurance_number, #minnesota_unemployment, #rhode_island_unemployment, #maine_unemployment, #oregon_unemployment, #colorado_unemployment, #iowa_unemployment, #utah_unemployment",
      ).on("keypress", function (e) {
        _this.element.validate().element(`#${e.target.id}`);
      });

      $(
        "#ownership_percentage, #ownership_percentage_2, #ownership_percentage_3, #ownership_percentage_4, #ownership_percentage_5",
      ).on("blur", function (e) {
        validatePercentage(e);
      });

      $("#hawaii_unemployment_insurance_number, #owner_count").on(
        "blur",
        function (e) {
          validateAlphaNumInput(e);
        },
      );

      const $tenants_improvements = $(
        "input[name='tenants_improvements_or_buildings']",
      );
      $tenants_improvements.on("keyup keypress click change", function (e) {
        $("#tenants_improvements_or_buildings-error").html(
          "Your policy must include public liability insurance, tenants' improvements or buildings insurance, contents insurance or all of them. Please choose at least one of these covers to continue.",
        );
        $tenants_improvements.attr(
          "data-msg",
          "Your policy must include public liability insurance, tenants' improvements or buildings insurance, contents insurance or all of them. Please choose at least one of these covers to continue.",
        );
      });

      const $include_contents = $("input[name='include_contents']");
      $include_contents.on("keyup keypress click change", function (e) {
        $("#include_contents-error").html(
          "Your policy must include public liability insurance, tenants' improvements or buildings insurance, contents insurance or all of them. Please choose at least one of these covers to continue.",
        );
        $include_contents.attr(
          "data-msg",
          "Your policy must include public liability insurance, tenants' improvements or buildings insurance, contents insurance or all of them. Please choose at least one of these covers to continue.",
        );
      });

      $(
        "#employer_reference_number_tax_office_code, #employer_reference_number_tax_office_employer_reference",
      ).on("change", function () {
        // Provide immediate validation feedback, instead of waiting until form submission
        _this.element.validate().element(this);
      });

      // Re-validate pl field when el changes
      $("#el_cover_limit").on("change", function () {
        if (_this._validator.submitted.pl_cover_limit) {
          _this.element.validate().element("#pl_cover_limit");
        }
      });

      // Validates that the secondary and primary trades are different before allowing the user to submit the form
      // Error message is triggered when the field is changed, or when the user tries to submit the form.
      if ((this.environment !== "production") && isUsSite()) {
        _this.element.on("validate", function (evt) {
          if (_this._validateSecondaryTradeQuestion()) {
        evt.preventDefault();
        $("#secondary_trade_selector-error").get(0).scrollIntoView();
          }
        });
        _this.element.on("render_errors", function () {
          _this._validateSecondaryTradeQuestion();
        });
        _this.element.on("change", '[name="secondary_trade"]', function () {
          _this._validateSecondaryTradeQuestion();
        });
        _this.element.on("change", '[name="have_secondary_trade"]', function () {
          _this._clearSecondaryTradeError();
        });
      }

      // Re-validate contactor payroll when either contactor payroll or annual revenue changes
      $("#annual_revenue, #subcontractor_payroll").on("change", function () {
        $("#subcontractor_payroll").length > 0 &&
          _this.element.validate().element("#subcontractor_payroll");
      });

      $("#business_type input").on("keyup keypress click", function () {
        _this.element.validate().element("input[name='business_type']");
      });

      // sof_warehouse_question
      $(".modal_control").on("change", function (e) {
        let name = e.target.getAttribute('name');
        let answer = '';
          if (e.target.value === 'no') {
            $("."+name+"_modal.disagree_modal").show();
            answer = 'disagree';
          } else {
            $("."+name+"_modal.disagree_modal").hide();
            answer = 'agree';
          }

        EventTracker.trigger("double_negative_question_modal", {
          question: name,
          answer: answer,
        });
      });
      /////////// Product exclusivity rules ///////////
      const productExclusivityRules = {
        general_liability: {
          el: $("#general_liability_coverage_yes"),
          productsThatShouldBeDisabled: {
            business_owners_policy: { reason: "coverage_cannot_be_combined_with_BOP"},
          },
        },
        business_owners_policy: {
          el: $("#business_owners_policy_coverage_yes"),
          productsThatShouldBeDisabled: {
            inland_marine: { reason: "coverage_is_included_with_BOP" },
            professional_liability: { reason: "buy_offline" },
            general_liability: { reason: "coverage_is_included_with_BOP" },
          },
        },
        inland_marine: {
          el: $("#inland_marine_coverage_yes"),
          productsThatShouldBeDisabled: {
            business_owners_policy: { reason: "coverage_cannot_be_combined_with_BOP" },
            professional_liability: { reason: "buy_offline" },
          },
        },
        professional_liability: {
          el: $("#professional_liability_coverage_yes"),
          productsThatShouldBeDisabled: {
            business_owners_policy: { reason: "buy_offline" },
            inland_marine: { reason: "buy_offline" },
          },
        },
      };

      function overlayTextElement(text, includePhoneLink) {
        return `
        <div class="disabled-partial-banner__inner">
          <p class="disabled-partial-banner__text">
            <span class="disabled-partial-banner__text-content">
              ${text}
            </span>
            ${ includePhoneLink ? '<a href="tel:8554801071" class="">(855) 480-1071</a>' : ''}
          </p>
        </div>
      `
     }

     function decideOverlayText(reasonsForBeingDisabled) {
       if (reasonsForBeingDisabled.includes("coverage_cannot_be_combined_with_BOP")) {
         return overlayTextElement(
           "This coverage cannot be combined with a Business Owner’s Policy",
           false
         )
       } else if (reasonsForBeingDisabled.includes("coverage_is_included_with_BOP")) {
         return overlayTextElement(
           "This coverage is included with the Business Owners Policy you selected",
           false
         )
       } else if (reasonsForBeingDisabled.includes("buy_offline")) {
         return overlayTextElement(
           "If you would like to purchase these coverages together, one of our agents can assist at ",
           true
         )
       }
     }

      const setOverlayText = (
        checkedProducts,
        productToDisableElement,
        productNameToDisable,
      ) => {
        const checkedProductsThatDisableThisOne = checkedProducts.filter(
          (checkedProductName) => {
            const productsThatTheCheckedProductDisables = Object.keys(
              productExclusivityRules[checkedProductName]
                .productsThatShouldBeDisabled,
            );
            return productsThatTheCheckedProductDisables.includes(
              productNameToDisable,
            );
          },
        );

        const reasonsForBeingDisabled = checkedProductsThatDisableThisOne.map(
          (product) => {
            return productExclusivityRules[product]
              .productsThatShouldBeDisabled[productNameToDisable]["reason"];
          },
        );

        const overlayTextContainer = productToDisableElement
          .closest(".control-block")
          .find(".disabled-partial-banner")
          .append(decideOverlayText(reasonsForBeingDisabled))
      };

      const disableProduct = (productNameToDisable, checkedProducts) => {
        const productToDisableElement =
          productExclusivityRules[productNameToDisable].el;
        productToDisableElement
          .closest(".control-block")
          .removeClass("--is-checked");

        productToDisableElement.prop("disabled", true);
        productToDisableElement.trigger("disabledPartial");

        setOverlayText(
          checkedProducts,
          productToDisableElement,
          productNameToDisable,
        );
      };

      const enableProduct = (product) => {
        product.prop("disabled", false);
        product.trigger("disabledPartial");

        product
          .closest(".control-block")
          .find(".disabled-partial-banner")
          .empty();
      };

      const findCheckedProducts = (productNames) => {
        const products = [];

        productNames.forEach((productName) => {
          const { el } = productExclusivityRules[productName];
          if (el[0] && el[0].checked) {
            products.push(productName);
          }
        });

        return products;
      };

      const productNamesThatCouldBeDisabled = () => {
        let products = [];

        Object.entries(productExclusivityRules).forEach(([, rule]) => {
          products = products.concat(
            Object.keys(rule.productsThatShouldBeDisabled),
          );
        });

        const uniqueProducts = [...new Set(products)];
        return uniqueProducts;
      };

      const productsThatShouldBeDisabled = (checkedProductNames) => {
        let products = [];

        checkedProductNames.forEach((productName) => {
          const rule = productExclusivityRules[productName];
          products = products.concat(
            Object.keys(rule.productsThatShouldBeDisabled),
          );
        });

        const uniqueProducts = [...new Set(products)];
        return uniqueProducts;
      };

      const productIsDisabled = (productName) => {
        return productExclusivityRules[productName].el.prop("disabled");
      };

      const ApplyProductExclusivityRules = () => {
        const allProductNamesThatCanBeDisabled =
          productNamesThatCouldBeDisabled();

        // reset all products so that we can reapply the exclusion rules again if
        // selected products have changed (i.e. user has checked/unchecked a product)
        allProductNamesThatCanBeDisabled.forEach((productName) => {
          if (productIsDisabled(productName)) {
            enableProduct(productExclusivityRules[productName].el);
          }
        });

        const checkedProductNamesWithExclusivityRules = findCheckedProducts(
          allProductNamesThatCanBeDisabled,
        );
        const productNamesToDisable = productsThatShouldBeDisabled(
          checkedProductNamesWithExclusivityRules,
        );

        productNamesToDisable.forEach((productName) => {
          disableProduct(productName, checkedProductNamesWithExclusivityRules);
        });
      };

      const productElementsWithExclusivityRules = Object.entries(
        productExclusivityRules,
      ).map(([, rule]) => {
        return rule.el;
      });

      productElementsWithExclusivityRules.forEach((productElement) => {
        productElement.on("click", function () {
          ApplyProductExclusivityRules();
        });
      });

      // To apply the rules on page load (for when someone is coming back from the next page with products
      // already selected)
      ApplyProductExclusivityRules();
      /////////// Product exclusivity rules ///////////

      contactDetailFields.forEach((id) => {
        $(`#buyer_${id}`).on("change", function () {
          _this.element.validate().element(`input[id=buyer_${id}]`);
        });

        $(`#customer_${id}`).on("change", function () {
          _this.element.validate().element(`input[id=customer_${id}]`);
        });
      });

      $(".shopping-cart").on("keyup keypress click", function () {
        // upsell page
        $(".shopping-cart-img")
          .removeClass("updated-cart")
          .addClass("normal-cart");
        $(".upsell__questionnaire").hide();
        $(".dashboard-coverage").hide();
        $(".upsell-page__coverage").addClass("shopping-cart-model");
        $(".site-footer").hide();
        $(".upsell-page .journey-form-buttons.mobile_buttons").hide();

        //legal agreement page
        $(".page-title").hide();
        $(".questionnaire").hide();

        //payment option page
        $(".qa-title").hide();
        $(".payment-grid-buttons").hide();
        $(".grid-wrapper.questionnaire").show();
        //quote-details-page
        $(".quote-details").hide();
        window.EventTracker &&
          window.EventTracker.trigger(
            "shopping_cart_cta",
            "cart summary opened",
          );
      });
      // if there is anything in the coverage summary then we can
      // show the shopping cart icon
      if ($(".upsell-page__coverage").length > 0) {
        $(".shopping-cart").addClass("visible-shopping-cart");
      }

      $("body").on("keyup keypress click", ".close-coverage", function () {
        // upsell page
        $(".upsell__questionnaire").show();
        $(".upsell-page__coverage").removeClass("shopping-cart-model");
        $(".site-footer").show();
        $(".dashboard-coverage").show();
        $(".upsell-page .journey-form-buttons.mobile_buttons").show();

        //legal agreement page
        $(".page-title").show();
        $(".questionnaire").show();

        //payment option page
        $(".qa-title").show();
        $(".payment-grid-buttons").show();

        $(".quote-details").show();

        if (window.EventTracker)
          window.EventTracker.trigger(
            "shopping_cart_cta",
            "cart summary closed",
          );
      });

      $("#uk_postcode input").on("keyup keypress click", function () {
        _this.element.validate().element("input[name='uk_postcode']");
      });

      $.validator.addMethod(
        "validate_consolidated_questions_answered",
        function (value, element) {
          if (value === "no" || value === undefined) {
            return true;
          }
          return (
            $(element)
              .parents(".primary-question")
              .find(".consolidated-questions")
              .find("input:visible:checked").length > 0
          );
        },
      );

      $.validator.addMethod(
        "validate_consolidated_yes_no_questions_answered",
        function (value, element) {
          if (value === "no" || value === undefined) {
            return true;
          }
          let consolidatedQuestions = $(element)
            .parents(".primary-question")
            .find(".consolidated-questions");
          return (
            consolidatedQuestions.find('input[value="no"]:visible:checked')
              .length !==
            consolidatedQuestions.find('input[value="no"]:visible').length
          );
        },
      );

      $.validator.addMethod(
        "validate_at_least_one_answered",
        function (value, element) {
          var additionalInsuredAnswered = $("input[name='additional_insured']:checked").length > 0;
          var waiverOfSubrigationAnswered = $("input[name='waiver_of_subrogation']:checked").length > 0;
          var noneOfTheAboveAnswered = $("input[name='none_of_the_above']:checked").length > 0;

          return additionalInsuredAnswered || waiverOfSubrigationAnswered || noneOfTheAboveAnswered;
        },
      );

      $.validator.addMethod(
        "validate_primary_and_noncontributory",
        function (value, element) {
          var additionalInsuredAnswered = $("input[name='additional_insured_test']:checked").length > 0;
          if (additionalInsuredAnswered) {
            return $("input[name='primary_and_noncontributory_test']:checked").length > 0;
          }
          return true;
        },
      );

      $.validator.addMethod("uk_postcode_default", function (value, element) {
        return $("input[name=uk_postcode]").val() !== "";
      });

      $.validator.addMethod(
        "validate_own_plant_value",
        function (value, element) {
          return parseInt(element.value) <= parseInt($("#own_plant").val());
        },
      );

      $.validator.addMethod(
        "validate_own_plant_sum_insured",
        function (value, element) {
          const values_sum = $(
            ".control-group.own_plant:not(.off) input[id^='own_plant_value_']",
          )
            .toArray()
            .reduce((sum, input) => sum + parseInt(input.value), 0);
          return values_sum <= parseInt($("#own_plant").val());
        },
      );

      $.validator.addMethod("validate_us_zipcode", function (value, element) {
        let validationResult = $(element).attr(
          "data-zip-code-validation-result",
        );

        try {
          return JSON.parse(validationResult);
        } catch {
          return true;
        }
      });

      $.validator.addMethod(
        "validate_mailing_us_zipcode",
        function (value, element) {
          let mailingValidationResult = $(element).attr(
            "mailing-data-zip-code-validation-result",
          );

          try {
            return JSON.parse(mailingValidationResult);
          } catch {
            return true;
          }
        },
      );

      $.validator.addMethod(
        "email",
        function (value, element) {
          var emailRegex =
            /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!xn--)[a-z0-9](?:[a-z0-9_-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])){1,}$/i;

          if (element.dataset.novalidate === "true")
            return this.optional(element) || emailRegex.test(value);
          else return emailRegex.test(value);
        },
        "Please enter a valid email address",
      );

      $.validator.addMethod(
        "validate_buildings_sum_insured_range_inclusion",
        function (value, element) {
          const min = element.dataset.min;
          const max = element.dataset.max;
          if (!min || !max) {
            return true;
          }

          const parsedValue = parseInt(value);
          return parsedValue >= parseInt(min) && parsedValue <= parseInt(max);
        },
      );

      $("input.js-rebuild-cost-input").on("change focusout", function () {
        _this.element.validate().element(this);
      });

      $("#disclosures input").on("change", function () {
        _this.element.validate().element("[name='disclosures[]']");
      });

      if (isBusinessUnitUS()) {
        $(".integer_answer").mask("#,##0", { reverse: true });
      }
      const validateTradeSelectorOnBlur = (element) => {
        $(element).on("blur", function () {
          const tradeSelector = $(element);
          if (
            !tradeSelector
              .closest(".control-block.on")
              .hasClass("state-selected") &&
            tradeSelector.val().length > 0
          ) {
            _this.element.validate().element(`#${element.id}`);
          }
          $(".view-all-trades").focus();
        });
      };

      function businessOwnersPolicyQuestionnaire() {
        return $("body").hasClass("business_owners_policy");
      }

      // clear validation errors so user can enter a new value and not think it is still invalid
      function clearValidationErrorsOnFocus(elemSelector, errorSpan) {
        elemSelector.on("focus", function () {
          if (elemSelector.hasClass("error")) {
            elemSelector.removeClass("error");
            errorSpan.remove();
          }
        });
      }

      if (businessOwnersPolicyQuestionnaire()) {
        const zipCode = $("#location_address_zip_code");
        const zipCodeErrorSpan = $("span#location-address-zip-code-error");

        const effectiveDate = $("#policy_effective_date");
        const effectiveDateErrorSpan = $("span#policy_effective_date-error");

        clearValidationErrorsOnFocus(zipCode, zipCodeErrorSpan);
        clearValidationErrorsOnFocus(effectiveDate, effectiveDateErrorSpan);
      }

      $(".trade-search-input").each((_, element) => {
        validateTradeSelectorOnBlur(element);
      });

      function validatePayrollFields() {
        function validatePayrollFieldIfPresent(id) {
          parseInt($(id).val(), 10) > 0 && _this.element.validate().element(id);
        }

        validatePayrollFieldIfPresent("#employee_payroll");
        validatePayrollFieldIfPresent("#owner_payroll");
        validatePayrollFieldIfPresent("#owner_payroll_2");
        validatePayrollFieldIfPresent("#owner_payroll_3");
        validatePayrollFieldIfPresent("#owner_payroll_4");
        validatePayrollFieldIfPresent("#owner_payroll_5");

        const ownerPayroll = $("#owner_payroll");
        if (ownerPayroll.hasClass("error")) {
          const employeePayroll = $("#employee_payroll");
          const eventDetail = `Employee Payroll = ${employeePayroll.val()} Owner Payroll = ${ownerPayroll.val()} - ${$("#owner_payroll-error").text()}`;
          window.EventTracker &&
            window.EventTracker.trigger(
              "invalid_owner_payroll_entered",
              "owner_payroll",
              eventDetail,
            );
        }
      }

      $.validator.addMethod(
        "validate_clear_business_customer_reference",
        function (value, element) {
          const regex =
            /^[A-Za-z0-9]{8,8}[-][A-Za-z0-9]{4,4}[-][A-Za-z0-9]{4,4}[-][A-Za-z0-9]{4,4}[-][A-Za-z0-9]{12,12}\b/g;
          return regex.test(value);
        },
      );

      if (backofficeQuestionnaire()) {
        $("#clear_business_customer_reference").on("blur", function (e) {
          _this.element.validate().element("input[name='customer[external_customer_reference]']");
        });
      }

      $(
        "#employee_payroll, #owner_payroll, #owner_payroll_2, #owner_payroll_3, #owner_payroll_4, #owner_payroll_5",
      ).on("blur :input", validatePayrollFields);
      $("#employee_count, #owner_count").on("change", validatePayrollFields);

      validatePayrollFields();

      // Re-validate sof_warehouse_stock_amount field when the value changes
      $("#sof_warehouse_stock_amount").on("change", function () {
        _this.element.validate().element("#sof_warehouse_stock_amount");
      });

      const plValidation = () => {
        $("#optional_public_liability").length > 0
          ? _this.element.validate().element("#optional_public_liability")
          : _this.element.validate().element("#public_liability");
      };

      if ($("body").hasClass("landlord")) {
        const revalidate_pl = function () {
          if (_this._validator.submitted.pl_cover_limit) {
            _this.element.validate().element("#pl_cover_limit");
          }
        };
        $("#contents_sum_insured").on("change", revalidate_pl);
        $("#buildings_sum_insured").on("change", revalidate_pl);
        $("#fixtures_and_fittings_sum_insured").on("change", revalidate_pl);
      } else if ($("body").hasClass("business")) {
        const revalidate_partners = function () {
          if (_this._validator.submitted.total_partners) {
            _this.element.validate().element("#total_partners_-_manual_trade");
            _this.element.validate().element("#total_partners");
            _this.element.validate().element("#clerical_partners");
          }
        };
        const revalidate_directors = function () {
          if (_this._validator.submitted.total_directors) {
            _this.element.validate().element("#total_directors_-_manual_trade");
            _this.element.validate().element("#total_directors");
            _this.element.validate().element("#clerical_directors");
          }
        };
        const revalidate_employees = function () {
          if (
            _this._validator.submitted.total_employees_ex_temp &&
            _this._validator.submitted.clerical_employees
          ) {
            _this.element.validate().element("#total_employees_ex_temp");
            _this.element.validate().element("#clerical_employees");
          }
        };

        $(
          "#total_partners, #clerical_partners, #total_partners_-_manual_trade, #total_employees_ex_temp, #clerical_employees, #total_employees_or_losc",
        ).on("change", revalidate_partners);
        $(
          "#total_directors, #clerical_directors, #total_directors_-_manual_trade, #total_employees_ex_temp, #clerical_employees, #total_employees_or_losc",
        ).on("change", revalidate_directors);
        $(
          "#total_employees_ex_temp, #total_employees_or_losc, #clerical_employees",
        ).on("change", revalidate_employees);
        $("#optional_public_liability, #professional_indemnity").on(
          "change",
          function () {
            if (_this._validator.submitted.pl_cover_limit) {
              _this.element.validate().element("#optional_public_liability");
              _this.element.validate().element("#professional_indemnity");
            }
          },
        );
        $("#professional_indemnity").on("change", function () {
          plValidation();
        });
      } else if ($("body").hasClass("professional")) {
        $("#public_liability, #professional_indemnity").on(
          "change",
          function () {
            if (_this._validator.submitted.pl_cover_limit) {
              _this.element.validate().element("#public_liability");
              _this.element.validate().element("#professional_indemnity");
            }
          },
        );
        $("input[name=el_cover_limit]").on("click", function () {
          plValidation();
        });
      }

      $("select#optional_public_liability, select#public_liability").on(
        "change",
        function () {
          _this.element.validate().element(this);
        },
      );

      $("#annual_payment").click(() => {
        $("#monthly_payment").prop("disabled", true);
      });

      $("#monthly_payment").click(() => {
        $("#annual_payment").prop("disabled", true);
      });

      $("#choose_your_cover_level_Solo").on("click", function () {
        $("#partners_cover_additional_price").html("£30");
        $("#family_cover_additional_price").html("£15");
      });

      $("#choose_your_cover_level_Solo_Plus").on("click", function () {
        $("#partners_cover_additional_price").html("£48");
        $("#family_cover_additional_price").html("£24");
      });

      $('input[name="policy_effective_date"], input[name="policy_start_date"]')
        .on("change", function () {
          _this.element.validate().element(this);
        })
        .on("focusout", function () {
          if (!$(this).val() || $(this).hasClass("error")) {
            // handle the user clicks into the text box and doesn't select anything
            _this.element.validate().element(this);
            _this.clearFieldValue($(this));
          }
        });
      $(
        "input[name=include_professional_liability], input[name=include_general_liability], input[name=include_workers_compensation]",
      ).on("click", function () {
        [
          "include_professional_liability",
          "include_general_liability",
          "include_workers_compensation",
        ].forEach((elm) => {
          $("input[name=" + elm + "]:checked").val() &&
            _this.element.validate().element("input[name=" + elm + "]");
        });
      });



      $(
        'input[name="same_correspondence_address"], input[name="same_correspondence_address_pre_quote"]',
      ).on("change", function () {
        $(".copyable_correspondence").toggleClass(
          "off",
          $(
            "#same_correspondence_address_yes, #same_correspondence_address_pre_quote_yes",
          ).is(":checked"),
        );

        function copyAddressData(value, field) {
          field.val(value).trigger("change");
        }

        if (
          $(
            "#same_correspondence_address_pre_quote_yes",
          ).is(":checked")
        ) {
          copyAddressData(
            $("#address_1_pre_quote").val(),
            $("#customer_address_1_pre_quote"),
          );
          copyAddressData(
            $("#address_2_pre_quote").val(),
            $("#customer_address_2_pre_quote"),
          );
          copyAddressData(
            $("#town_pre_quote").val(),
            $("#customer_town_pre_quote"),
          );
          copyAddressData(
            $("#uk_postcode_pre_quote").val(),
            $("#customer_postcode_pre_quote"),
          );
        }
      });

      $("#address_1_pre_quote").on("change", function () {
        if (
          $(
            "#same_correspondence_address_pre_quote_yes",
          ).is(":checked")
        ) {
          $("#customer_address_1_pre_quote").val(this.value);
        }
      });

      $("#address_2_pre_quote").on("change", function () {
        if (
          $(
            "#same_correspondence_address_pre_quote_yes",
          ).is(":checked")
        ) {
          $("#customer_address_2_pre_quote").val(this.value);
        }
      });

      $("#town_pre_quote").on("change", function () {
        if (
          $(
            "#same_correspondence_address_pre_quote_yes",
          ).is(":checked")
        ) {
          $("#customer_town_pre_quote").val(this.value);
        }
      });

      $("#uk_postcode_pre_quote").on("change", function () {
        if (
          $(
            "#same_correspondence_address_pre_quote_yes",
          ).is(":checked")
        ) {
          $("#customer_postcode_pre_quote").val(this.value);
        }
      });

      // warning widgets
      $('#business_name[data-enable-warnings="true"]').business_name_check();

      $("#same-address").on("change", function () {
        if (this.checked) {
          $("#customer_address_1").val(business_address_1);
          $("#customer_address_2").val(business_address_2);
          $("#customer_town").val(business_city);
          $("#customer_subdivision").val(business_subdivision);
          $("#customer_postcode").val(business_zipcode);
        }
      });

      setupRebuildCostInputEvents();

      const verifyAddress = function () {
        const usZipCode = $("input[name='us_zipcode']");
        if (usZipCode.length == 0) {
          return;
        }
        if (!usZipCode.val()) {
          return;
        }
        if (usZipCode.val().length < 5) {
          return;
        }

        const formData = _this.element.serialize();
        _this.disableButton();
        var currentXhr = $.ajax({
          type: "POST",
          url: `${location.pathname}?step_action=verify_address`,
          data: formData,
          dataType: "json",
        })
          .done(function (data) {
            if (!data.state_name) {
              return;
            }

            const element = $("input[name='us_zipcode']");
            element.attr("data-zip-code-validation-result", data.status);
            element.attr(
              "data-zip-code-validation-state-name",
              data.state_name,
            );

            $("input[name='business_city']").val(data.city_for_zipcode);

            if (data.status === false) {
              window.EventTracker &&
                window.EventTracker.trigger(
                  "invalid_state_zip_code_entered",
                  "us_zipcode",
                  `${data.state_name}/${data.zip_code} - Looks like that zip code is not in ${data.state_name}. Try updating your zip code.`,
                );
            }
            _this.element.validate().element("[name='us_zipcode']");
          })
          .always(function () {
            _this.enableButton();

            if (_this._activeXhrRequest !== currentXhr) return; // this means that there's a later request executed; disregard the results here, because only the latest response should be used

            // signal that we're no longer waiting for an xhr response
            _this._activeXhrRequest = null;
          });
        _this._activeXhrRequest = currentXhr;
      };

      $("input#us_zipcode").on("input", verifyAddress);
      $("select#us_state").on("change", verifyAddress);
      verifyAddress();

      const verifyMailingAddress = function () {
        const mailingUsZipCode = $("input[name='mailing_us_zipcode']");
        if (mailingUsZipCode.length == 0) {
          return;
        }
        if (!mailingUsZipCode.val()) {
          return;
        }
        if (mailingUsZipCode.val().length < 5) {
          return;
        }

        const formData = _this.element.serialize();
        _this.disableButton();
        var currentXhr = $.ajax({
          type: "POST",
          url: `${location.pathname}?step_action=verify_mailing_address`,
          data: formData,
          dataType: "json",
        })
          .done(function (data) {
            if (!data.state_name) {
              return;
            }

            const element = $("input[name='mailing_us_zipcode']");
            element.attr(
              "mailing-data-zip-code-validation-result",
              data.status,
            );
            element.attr(
              "mailing-data-zip-code-validation-state-name",
              data.state_name,
            );

            $("input[name='mailing_city']").val(data.city_for_zipcode);

            if (data.status === false) {
              window.EventTracker &&
                window.EventTracker.trigger(
                  "invalid_state_zip_code_entered",
                  "mailing_us_zipcode",
                  `${data.state_name}/${data.zip_code} - Looks like that mailing zip code is not in ${data.state_name}. Try updating your zip code.`,
                );
            }
            _this.element.validate().element("[name='mailing_us_zipcode']");
          })
          .always(function () {
            _this.enableButton();

            if (_this._activeXhrRequest !== currentXhr) return; // this means that there's a later request executed; disregard the results here, because only the latest response should be used

            // signal that we're no longer waiting for an xhr response
            _this._activeXhrRequest = null;
          });
        _this._activeXhrRequest = currentXhr;
      };

      $("input#mailing_us_zipcode").on("input", verifyMailingAddress);
      $("select#mailing_us_state").on("change", verifyMailingAddress);
      verifyMailingAddress();

      loqateAddressAutocomplete("#address_autocomplete");

      if (window.EventTracker && typeof SB !== "undefined") {
        const trackingResult = new SB.TrackingResult();
        this.visibleSectionElement = $(".js-toggleable-section:visible");
        this.visibleSectionElement.sectionTracker(
          function (section, index, result) {
            const isChanged = trackingResult.isChanged(index, result);
            if (isChanged) {
              EventTracker.trigger(
                "pageset_section_changed",
                $(section).data(),
                index + 1,
                result,
              );
            }
          },
        );
        this.visibleSectionElement.sectionTracker.check();
        setInterval(this.visibleSectionElement.sectionTracker.check, 1000);
      }
      this._setupQuestionnaire();
      this._initHelpTooltip();
      this._initAnnualTurnoverQuestion();
      this._triggerRebuildTpdData();

      // Add a data attribute to the form to indicate that the smart form has been enabled
      _this.element.attr('data-smart-form-loaded', true);
    },

    _trackSubmitted() {
      this._trackInvalidFields();
      if (this._validator.errorList.length == 0) {
        this.visibleSectionElement.sectionTracker.check();
      }
    },

    _trackInvalidFields() {
      const { errorList } = this._validator;
      const { errorMap } = this._validator;

      for (let i = 0; i < errorList.length; i++) {
        const { element } = errorList[i];
        const isUncheckedRadioButton =
          element.type === "radio" && !element.checked;
        const isUncheckedCheckbox =
          element.type === "checkbox" && !element.checked;
        const elementValue =
          isUncheckedRadioButton || isUncheckedCheckbox || !$(element).val()
            ? "BLANK"
            : $(element).val();

        // errorMessage is sanitized to remove html elements
        const errorMessage = errorMap[element.name].replace(
          /<\/?[^>]+(>|$)/g,
          "",
        );
        const elementValueMessage = `${elementValue} - ${errorMessage}`;
        EventTracker.trigger(
          "invalid_field_submitted",
          element.name,
          elementValueMessage,
        );
      }
    },

    logger(message, data) {
      if (this.environment !== "test") return;
      console.log(`${message} ${JSON.stringify(data)}`);
    },

    getEnvironmentName() {
      const meta = document.querySelector("meta[name=env]");
      return meta ? meta.getAttribute("content") : "";
    },

    _setupQuestionnaire() {
      //when form element is removed during refresh question processing
      //all events associated with element also removed hence changing on event
      //to include the ones created dynamically.
      //https://github.com/simplybusiness/chopin/blob/master/app/assets/javascripts/ci5/smart_form.js#L652
      this.element.on(
        "change",
        "[data-trigger=refresh] :input",
        this._getAnswerChangedEventHandler(),
      );

      //to include the ones created dynamically.
      this.element.on(
        "change",
        ".js-custom-question-trigger",
        this._getCustomiseTriggerChangedEventHandler(),
      );

      // Prevent form submission when there's an active request, until the request finishes
      const _this = this;
      this.element.on("validate", function (e) {
        if (!_this._activeXhrRequest) return;

        _this._activeXhrRequest.always(function () {
          if (_this.element.valid()) {
            _this.element.submit();
          } else {
            if (_this.options.pleaseWait) {
              _this.enableButton();
            }
            _this._validator.focusInvalid();
          }
        });

        if (_this.options.pleaseWait) {
          _this.disableButton();
        }

        e.stopImmediatePropagation();
        e.preventDefault();
      });
    },

    _questionData(index, domElement) {
      const q = $(domElement);
      return {
        question: q,
        name: q.data("question"),
      };
    },

    _getAnswerChangedEventHandler() {
      const _this = this;
      // The update to the displayed answers should not attempt to display any of the
      // correspondence questions, as the show/hide behaviour for those is handled by a separate event.
      const groups = _this.element
        // The `.not` exclusion is included here as we believe we should not expose the correspondence address
        // while requesting `check_questionnaire`
        .find(".js-toggleable-section .control-group")
        .not(".copyable_correspondence")
        .not(".address-autocomplete-group");
      const sections = _this.element.find(".js-toggleable-section");
      const questions = this.element
        .find(".js-toggleable-section .control-block")
        .not(".address-autocomplete-block")
        .not(".skipped")
        .map(this._questionData);

      return function updateQuestionnaireOnAnswerChange() {
        const changedElement = this;
        const formData = _this.element.serialize();
        _this.logger("answer changed for", changedElement.id);
        _this.logger("form data sent", formData);

        let checkQuestionnaireStep = "check_questionnaire";
        var currentXhr = $.ajax({
          type: "POST",
          url: `${location.pathname}?step_action=` + checkQuestionnaireStep,
          data: formData,
          dataType: "json",
        })
          .done(function (data) {

            // if there's a later request executed, disregard the results here,
            // because only the latest response should be used
            if (_this._activeXhrRequest !== currentXhr) return;

            // We want to see what questions are being changed
            // due to a flaky spec that couldn't find an element
            _this.logger("data received", data);

            if (backofficeQuestionnaire()) {
              updateBackofficeThirdPartyDataInfo(data.tpd_enriched_questions);
            }

            questions.each(function () {
              const questionName = this.name;
              const toggleFlag = $.inArray(questionName, data.questions) > -1;
              const $questionInput = this.question.find("input");

              _this.toggleQuestion(this.question, toggleFlag);
              toggleDynamicSecondaryText(questionName, toggleFlag);

              if (data.enriched_questions.hasOwnProperty(questionName)) {
                const enrichedQuestion = data.enriched_questions[questionName];

                // needed to control 'buildings_sum_insured' TPD pre-populated question state
                if ($questionInput.attr("name") == "buildings_sum_insured") {
                  updateRebuildCostInputState(
                    this.question,
                    enrichedQuestion,
                    data.tpd_enriched_questions,
                    backofficeQuestionnaire(),
                  );
                }

                this.question.find(":input").each(function () {
                  _this.setFieldValue($(this), enrichedQuestion);
                });
              }

              if (data.refreshed_questions.hasOwnProperty(questionName)) {
                this.question.find(".control").remove();
                this.question.append(data.refreshed_questions[questionName]);
                // re-attaching events as these are new elements attached to form
                window &&
                  window.EventTracker &&
                  window.EventTracker.attach(this.question);
              }

              if (data.enriched_questions.hasOwnProperty(questionName)) {
                if (this.question.hasClass("percentage-control__group")) {
                  const $total = this.question.find(":input");
                  const percentage = data.enriched_questions[questionName];
                  const $infoMsg = $($total.parents()).find(
                    ".percentage-alert",
                  );
                  $total.val(percentage + "%");
                  if ($total.hasClass("error") && percentage != 0) {
                    $infoMsg
                      .addClass("percentage-error")
                      .html(
                        $total.attr("data-msg") +
                          " <b>(current total " +
                          percentage +
                          "%)</b>",
                      );
                  } else {
                    $infoMsg
                      .removeClass("percentage-error")
                      .html($total.attr("data-msg"));
                  }

                  _this.element
                    .find(".qa-next-button")
                    .on("click", function (e) {
                      e.stopImmediatePropagation();
                      if ($infoMsg.hasClass("percentage-error")) {
                        window &&
                          window.EventTracker &&
                          window.EventTracker.trigger(
                            "percent_work_total_submitted",
                            percentage,
                          );
                      }
                    });
                }
              }
            });

            groups.each(function () {
              const g = $(this);
              g.toggleClass("off", g.find(".control-block.on").length === 0);
            });

            sections.each(function () {
              const s = $(this);
              s.toggleClass(
                "off",
                s.find(".control-block.on").not(".address-autocomplete-block")
                  .length === 0,
              );
            });
            toggleConsolidatedQuestionsGroup();

            //Dispatch a synthetic change event so that external listeners on the form know that the form changed
            _this.element[0].dispatchEvent(new Event("change"));
          })
          .fail(function (_jqXHR, textStatus) {
            if (_this._activeXhrRequest !== currentXhr) return; // this means that there's a later request executed; disregard the results here, because only the latest response should be used
            const errorCode = _jqXHR.status;
            if (errorCode === 400) displayAjaxErrorMessage(changedElement);

            _this.logger("Ajax failed with ", textStatus);
            const response = _jqXHR.responseJSON;
            const errorMessage = response && response.message;
            if (errorMessage) $(changedElement).flashError(errorMessage);
          })
          .always(function () {
            if (_this._activeXhrRequest !== currentXhr) return; // this means that there's a later request executed; disregard the results here, because only the latest response should be used

            // signal that we're no longer waiting for an xhr response
            _this._activeXhrRequest = null;
          });

        // signal that this is the currently active request
        _this._activeXhrRequest = currentXhr;
      };
    },

    _getCustomiseTriggerChangedEventHandler() {
      const _this = this;
      const questions = this.element
        .find(".js-toggleable-section .control-block")
        .map(this._questionData);

      return function updateQuestionnaireOnCustomiseTriggerChange() {
        const changedElement = this;
        const formData = _this.element.serialize();
        _this.logger("answer changed for", changedElement.id);
        _this.logger("form data sent", formData);

        var currentXhr = $.ajax({
          type: "POST",
          url: `${location.pathname}?step_action=customise_questions`,
          data: formData,
          dataType: "json",
        })
          .done(function (data) {
            // if there's a later request executed, disregard the results here,
            // because only the latest response should be used
            if (_this.__activeXhrRequestForCustomiseQuestions !== currentXhr)
              return;

            // We want to see what questions are being changed
            // due to a flaky spec that couldn't find an element
            _this.logger("data received", data);
            questions.each(function () {
              const questionName = this.name;

              if (data.customised_questions.hasOwnProperty(questionName)) {
                const { question } = this;

                question
                  .find(".control-label")
                  .html(data.customised_questions[questionName].primary_text);
                question
                  .find(".secondary-text")
                  .html(data.customised_questions[questionName].secondary_text);
                question
                  .find(".tertiary-text")
                  .html(data.customised_questions[questionName].tertiary_text);
                question
                  .find(".help-content")
                  .html(data.customised_questions[questionName].help_text);
              }
            });
          })
          .fail(function (_jqXHR, textStatus) {
            if (_this.__activeXhrRequestForCustomiseQuestions !== currentXhr)
              return; // this means that there's a later request executed; disregard the results here, because only the latest response should be used

            _this.logger("Ajax customise_questions failed with ", textStatus);
          })
          .always(function () {
            if (_this.__activeXhrRequestForCustomiseQuestions !== currentXhr)
              return; // this means that there's a later request executed; disregard the results here, because only the latest response should be used

            // signal that we're no longer waiting for an xhr response
            _this.__activeXhrRequestForCustomiseQuestions = null;
          });
        // signal that this is the currently active request
        _this.__activeXhrRequestForCustomiseQuestions = currentXhr;
      };
    },

    _validateSecondaryTradeQuestion() {
      const $secondaryTradeBlock = $('[name="secondary_trade"]').closest('.control-block');
      const secondaryTradeValue = $('[name="secondary_trade"]').val();
      const primaryTradeValue = $('[name="primary_trade"]').val();
      const tradesMatch = !!secondaryTradeValue && !!primaryTradeValue && secondaryTradeValue === primaryTradeValue;

      $secondaryTradeBlock.toggleClass('error', tradesMatch);
      if (tradesMatch) {
        this._displaySecondaryTradeError();
        this._trackValidateSecondaryTradeQuestion(true);
      } else {
        $('#secondary_trade_selector-error').remove();
      }
      return tradesMatch;
    },

    _displaySecondaryTradeError() {
      const errorMessage = "You've already selected this as your trade. Please choose a different secondary service if you have one.";

      $('#secondary_trade_selector-error').remove();
      $('[name="secondary_trade"]')
        .closest('.control-block')
        .find('.control.search')
        .after(
          '<span id="secondary_trade_selector-error" class="error">' + errorMessage + '</span>'
        );
    },

    _clearSecondaryTradeError() {
      $('#secondary_trade_selector-error').remove();
    },

    _trackValidateSecondaryTradeQuestion() {
      EventTracker.trigger("same_primary_and_secondary_trade_selected_error");
    },

    toggleQuestion(questions, toggle) {
      const _this = this;

      questions.each(function () {
        const question = $(this);
        const event = $.Event();

        if (toggle && question.hasClass("off")) {
          event.type = "questionShow";
          question.trigger(event);
        } else if (!toggle && question.hasClass("on")) {
          event.type = "questionHide";
          question.trigger(event);
        } else {
          return;
        }

        if (event.isDefaultPrevented()) {
          return;
        }

        const inputs = question
          .toggleClass("on", toggle)
          .toggleClass("off", !toggle)
          .find(":input")
          .prop("disabled", !toggle);

        if (!toggle) {
          _this.element.infoBoxSet("hide", question);

          inputs.each(function () {
            _this.clearFieldValue($(this));
            _this._validator.resetField($(this));
          });
        }
      });
    },

    _initHelpTooltip() {
      const _this = this;

      this.element.infoBoxSet({
        animate: this.options.animateHelp,
      });

      // Inject help icons

      this.element.find(".info-box").each(function () {
        const $el = $(this);
        const $controlLabel = $el.find(".control-label:first");
        if ($controlLabel.has("ul").length > 0) {
          $controlLabel.find("ul").before(_this.options.helpTriggerHtml);
        } else {
          $controlLabel.after(_this.options.helpTriggerHtml);
        }
      });

      // Toggle help icon label on help show/hide

      this._on({
        infoboxsetshown(e, data) {
          const helpTrigger =
            (data && data.box && data.box.find(".help-trigger:first")) || {};
          const primaryText =
            helpTrigger.siblings(".control-label") &&
            helpTrigger.siblings(".control-label").html();
          const helpBody = helpTrigger.siblings(".help-text");
          helpTrigger.attr("aria-describedby", helpBody.attr("id"));
          const helpHtml =
            helpBody &&
            helpBody.find(".help-content") &&
            helpBody.find(".help-content div").html();
          const helpText = $("<div>").append(helpHtml).clone().text();

          window &&
            window.EventTracker &&
            primaryText &&
            helpText &&
            window.EventTracker.trigger(
              "help_text_opened",
              primaryText,
              helpText,
            );
          helpTrigger.html(_this.options.closedHelpTriggerText);
          helpTrigger.attr("aria-label", "Help");
          helpTrigger.attr("aria-expanded", "true");
        },

        infoboxsethidden(e, data) {
          const helpTrigger =
            (data && data.box && data.box.find(".help-trigger:first")) || {};
          helpTrigger.html(_this.options.openHelpTriggerText);
          helpTrigger.attr("aria-label", "Help");
          helpTrigger.attr("aria-expanded", "false");
          helpTrigger.removeAttr("aria-describedby");
        },
      });

      // Toggle open help box labels on breakpoint change
      if (this.options.resetLabelsOnBreakpoint) {
        this._onBreakpoint(
          "desktop",
          function () {
            _this.element
              .find(".info-box-active .help-trigger")
              .html(_this.options.openHelpTriggerText);
          },
          function () {
            _this.element
              .find(".info-box-active .help-trigger")
              .html(_this.options.closedHelpTriggerText);
          },
        );
      }

      // Show / hide help when focusing on inputs for desktop breakpoint only

      if (this.options.showHelpOnFocus) {
        this._on({
          "focus :input": function (e) {
            if (
              this.options.breakpoint === this.options.showHelpAutoOnBreakpoint
            ) {
              const box = $(e.currentTarget).closest(".control-block");
              if (box.hasClass("info-box")) {
                this.element.infoBoxSet("show", box);
              } else {
                this.element.infoBoxSet("hide");
              }
            }
          },
          "blur :input": function (e) {
            if (
              this.options.breakpoint === this.options.showHelpAutoOnBreakpoint
            ) {
              const box = $(e.currentTarget).closest(".control-block");
              if (box.hasClass("info-box")) {
                this.element.infoBoxSet("hide");
              }
            }
          },
        });
      }

      // Show / hide help on hover for desktop only

      if (this.options.showHelpOnHover) {
        this._on({
          "mouseenter .control-block": function (e) {
            if (
              this.options.breakpoint === this.options.showHelpAutoOnBreakpoint
            ) {
              this.element.infoBoxSet("show", $(e.currentTarget));
            }
          },

          "mouseleave .control-block": function (e) {
            const currentElem$ = $(e.currentTarget);
            if (
              this.options.breakpoint ===
                this.options.showHelpAutoOnBreakpoint &&
              (!this.options.showHelpOnFocus ||
                !currentElem$.find("input").is(":focus"))
            ) {
              this.element.infoBoxSet("hide", currentElem$);
            }
          },
        });
      }
    },

    _initAnnualTurnoverQuestion() {
      this.element.annualTurnoverQuestion();
    },

    _triggerRebuildTpdData() {
      if ($('body[data-journey-name="frontoffice_mta"]').hasClass("landlord")) {
        // trigger pre-pop on frontoffice mta landlord vertical
        this.element
          .find("[data-trigger='refresh']:visible :input")
          .eq(0)
          .change();
      }
    },
  });

  $.validator.addMethod("validate_tax_office_code", function (value, element) {
    const taxOfficeCodePattern = /^[0-9]{3}$/;
    const assertions = [ernNumberPartValid(value, taxOfficeCodePattern)];

    return !!assertions.every(Boolean);
  });

  $.validator.addMethod("validate_disclosures", function (value, element) {
    const values = $("input[name='disclosures[]']:checked").map(
      (_index, element) => element.value,
    );
    return !(values.length === 1 && values[0] == "Receive by post");
  });

  const stringToInt = (value) => value && parseInt(value.replace(/,/g, ""), 10);

  $.validator.addMethod(
    "validate_owner_employee_payroll",
    function (value, element) {
      if (stringToInt($("#owner_count").val()) >= 1) {
        if (totalOwnerPayroll() > stringToInt($("#employee_payroll").val())) {
          return false;
        }
      } else if (
        stringToInt(value) > stringToInt($("#employee_payroll").val())
      ) {
        return false;
      }
      return true;
    },
  );

  $.validator.addMethod(
    "validate_owner_payroll_not_equal_employee_payroll",
    function (value, element) {
      if (workersCompensationQuestionnaire()) {
        if (stringToInt($("#owner_count").val()) > 1) {
          if (
            totalOwnerPayroll() === stringToInt($("#employee_payroll").val())
          ) {
            return false;
          }
        } else if (
          stringToInt(value) === stringToInt($("#employee_payroll").val())
        ) {
          return false;
        }
      }
      return true;
    },
  );

  $.validator.addMethod(
    "validate_total_payroll_owner_payroll",
    function (value, element) {
      if (stringToInt($("#employee_payroll").val()) - totalOwnerPayroll() == 0)
        displayPayrollMessage($("#employee_payroll"), "insertAfter");
      else displayPayrollMessage($("#employee_payroll"), "remove");
      return true;
    },
  );

  $.validator.addMethod(
    "validate_ownership_percentage_total",
    function (value, element) {
      return totalOwnershipPercentage() !== 100 ? false : true;
    },
  );

  $.validator.addMethod("eligible_wc_state", function (value, element) {
    const monopolisticStates = [
      "North Dakota",
      "Ohio",
      "Washington",
      "Wyoming",
    ];

    return !monopolisticStates.includes($("#us_state").val());
  });

  $.validator.addMethod("validate_us_gl_cover", function (value, element) {
    const plAdded = $("input[name=include_professional_liability]:checked");
    const plVisible = $("input[name=include_professional_liability]:visible");
    const wcAdded = $("input[name=include_workers_compensation]:checked");
    const wcVisible = $("input[name=include_workers_compensation]:visible");

    if (!plVisible.length && !wcVisible.length) {
      return value == "yes";
    }

    if (wcVisible.length > 0) {
      return !(value == "no" && plAdded.val() == "no" && wcAdded.val() == "no");
    }

    return !(value == "no" && plAdded.val() == "no");
  });

  $.validator.addMethod("validate_us_pl_cover", function (value, element) {
    const glAdded = $("input[name=include_general_liability]:checked");
    const wcVisible = $("input[name=include_workers_compensation]:visible");
    const wcAdded = $("input[name=include_workers_compensation]:checked");

    if (wcVisible.length > 0) {
      return !(value == "no" && glAdded.val() == "no" && wcAdded.val() == "no");
    }

    return !(value == "no" && glAdded.val() == "no");
  });

  $.validator.addMethod("validate_us_wc_cover", function (value, element) {
    const glAdded = $("input[name=include_general_liability]:checked");
    const plAdded = $("input[name=include_professional_liability]:checked");
    return !(value == "yes" && glAdded.val() == "no" && plAdded.val() == "no");
  });

  $.validator.addMethod("validate_us_all_cover", function (value, element) {
    const glAdded = $("input[name=include_general_liability]:checked");
    const plAdded = $("input[name=include_professional_liability]:checked");
    const wcAdded = $("input[name=include_workers_compensation]:checked");
    return !(
      wcAdded.val() == "no" &&
      glAdded.val() == "no" &&
      plAdded.val() == "no"
    );
  });

  $.validator.addMethod(
    "validate_tax_office_employer_reference",
    function (value, element) {
      const taxOfficeEmployerReferencePattern = /^[A-Za-z]{1,2}[0-9]{1,6}$/;
      const assertions = [
        ernNumberPartValid(value, taxOfficeEmployerReferencePattern),
      ];

      return !!assertions.every(Boolean);
    },
  );

  $.validator.addMethod(
    "validate_landlord_cover_options",
    function (value, element) {
      const contents_sum_insured = $(
        "[name=contents_sum_insured]:visible",
      ).val();
      const buildings_sum_insured =
        $("[name=buildings_sum_insured]:visible").val() ||
        isThirdPartyRebuildCostView();
      const fixtures_and_fittings_sum_insured = $(
        "[name=fixtures_and_fittings_sum_insured]:visible",
      ).val();
      return (
        contents_sum_insured ||
        buildings_sum_insured ||
        fixtures_and_fittings_sum_insured
      );
    },
  );

  $.validator.addMethod(
    "no_manual_workers_partners",
    function (value, element) {
      if (
        $("#total_partners_-_manual_trade").closest(".control-block.on")
          .length > 0 &&
        window.location.pathname.indexOf("/backoffice/") != 0
      ) {
        const total_partners = parseInt(
          $("#total_partners_-_manual_trade").val(),
          10,
        );
        const total_employees =
          parseInt($("#total_employees_or_losc").val(), 10) ||
          parseInt($("#total_employees_ex_temp").val(), 10);
        const clerical_partners = parseInt($("#clerical_partners").val(), 10);
        const clerical_employees = parseInt($("#clerical_employees").val(), 10);

        const have_employees =
          $("input[id='have_employees_or_losc_yes']:checked").val() ||
          $("input[id='have_employees_or_losc_no']:checked").val() ||
          $("input[id='have_employees_ex_temp_yes']:checked").val() ||
          $("input[id='have_employees_ex_temp_no']:checked").val();

        if (
          have_employees == "yes" &&
          total_employees &&
          total_partners &&
          clerical_employees &&
          clerical_partners
        ) {
          return (
            total_partners + total_employees >
            clerical_partners + clerical_employees
          );
        }
        if (have_employees == "no" && total_partners && clerical_partners) {
          return total_partners > clerical_partners;
        }
        return true;
      }
      return true;
    },
  );

  $.validator.addMethod("validate_pl_limit_amount", function (value, element) {
    if (
      element.dataset.plLimit === undefined ||
      element.dataset.plLimit === "-1"
    )
      return true;
    return Number(value) <= Number(element.dataset.plLimit);
  });

  $.validator.addMethod("validate_not_required", plValidationNotRequired);

  $.validator.addMethod(
    "no_manual_workers_directors",
    function (value, element) {
      if (
        $("#total_directors_-_manual_trade").closest(".control-block.on")
          .length > 0
      ) {
        const total_directors = parseInt(
          $("#total_directors_-_manual_trade").val(),
          10,
        );
        const total_employees =
          parseInt($("#total_employees_or_losc").val(), 10) ||
          parseInt($("#total_employees_ex_temp").val(), 10);
        const clerical_directors = parseInt($("#clerical_directors").val(), 10);
        const clerical_employees = parseInt($("#clerical_employees").val(), 10);

        const have_employees =
          $("input[id='have_employees_or_losc_yes']:checked").val() ||
          $("input[id='have_employees_or_losc_no']:checked").val() ||
          $("input[id='have_employees_ex_temp_yes']:checked").val() ||
          $("input[id='have_employees_ex_temp_no']:checked").val();

        if (
          have_employees == "yes" &&
          total_employees &&
          total_directors &&
          clerical_employees &&
          clerical_directors
        ) {
          return (
            total_directors + total_employees >
            clerical_directors + clerical_employees
          );
        }
        if (have_employees == "no" && total_directors && clerical_directors) {
          return total_directors > clerical_directors;
        }
        return true;
      }
      return true;
    },
  );

  $.validator.addMethod("less_than_total_partners", function (value, element) {
    if (
      ($("#total_partners_-_manual_trade").closest(".control-block.on").length >
        0 ||
        $("#total_partners").closest(".control-block.on").length > 0) &&
      $("#clerical_partners").closest(".control-block.on").length > 0
    ) {
      const total_partners =
        parseInt($("#total_partners_-_manual_trade").val(), 10) ||
        parseInt($("#total_partners").val(), 10) ||
        0;

      return total_partners >= parseInt($("#clerical_partners").val(), 10);
    }
    return true;
  });

  $.validator.addMethod("less_than_annual_revenue", function (value, element) {
    const $subcontractorPayroll = $("#subcontractor_payroll");

    const $annualRevenue = $("#annual_revenue");
    const formatCost = (cost) => parseInt(cost.replace(/,/g, ""), 10);

    if (
      ($subcontractorPayroll.closest(".control-block.on").length > 0 ||
        $subcontractorPayroll.closest(".control-block.on").length > 0) &&
      $annualRevenue.closest(".control-block.on").length > 0
    ) {
      return (
        formatCost($annualRevenue.val()) >=
        formatCost($subcontractorPayroll.val())
      );
    }
    return true;
  });

  $.validator.addMethod("less_than_total_directors", function (value, element) {
    if (
      ($("#total_directors_-_manual_trade").closest(".control-block.on")
        .length > 0 ||
        $("#total_directors").closest(".control-block.on").length > 0) &&
      $("#clerical_directors").closest(".control-block.on").length > 0
    ) {
      const total_directors =
        parseInt($("#total_directors_-_manual_trade").val(), 10) ||
        parseInt($("#total_directors").val(), 10) ||
        0;

      return total_directors >= parseInt($("#clerical_directors").val(), 10);
    }
    return true;
  });

  $.validator.addMethod("less_than_total_employees", function (value, element) {
    if (
      ($("#total_employees_ex_temp").closest(".control-block.on").length > 0 ||
        $("#total_employees_or_losc").closest(".control-block.on").length >
          0) &&
      $("#clerical_employees").closest(".control-block.on").length > 0
    ) {
      const total_employees =
        parseInt($("#total_employees_ex_temp").val(), 10) ||
        parseInt($("#total_employees_or_losc").val(), 10);
      return total_employees >= parseInt($("#clerical_employees").val(), 10);
    }
    return true;
  });

  const getBackofficeAnswer = (element) => {
    if (element.length > 0 && element.val() != "") {
      return element.val();
    }
    return false;
  };

  const getStockLevel = (element) => {
    // frontoffice - stock_sum_insured value passed from cover options page
    // to agreements page through sof_warehouse_stock_amount "stock-level" attribute
    let stockLevel = $(element).data("stock-level"),
      stockSumInsured = getBackofficeAnswer($("#stock_sum_insured"));

    // backoffice - stock_sum_insured element present on same page
    // hence we can check against same page stock_sum_insured value.
    stockLevel = stockSumInsured || stockLevel;
    return stockLevel;
  };

  $.validator.addMethod("no_stock_cover_selected", function (value, element) {
    if ($(element).closest(".control-block.on").length > 0) {
      const stockLevel = getStockLevel(element);
      return !(parseInt(value) > 0 && stockLevel == "Not selected");
    }
    return true;
  });

  $.validator.addMethod("less_than_stock_cover", function (value, element) {
    if ($(element).closest(".control-block.on").length > 0) {
      const stockLevel = getStockLevel(element);
      return !(parseInt(value) > stockLevel);
    }
    return true;
  });

  $.validator.addMethod("must_be_an_integer", function (value, element) {
    return !isNaN(parseInt(value));
  });

  $.validator.addMethod("added_maximum_value", function (value, element) {
    return value <= 9_999;
  });

  $.validator.addMethod("from_two_to_five", function (value, element) {
    let partnership_business_types = [
      "Partnership",
      "Limited Liability Partnership (LLP)",
    ];

    if (partnership_business_types.includes($("#business_type").val())) {
      return value >= 2 && value <= 5;
    }
    return value;
  });

  $.validator.addMethod("contains_four_digits", function (value, element) {
    return value.replace(/\D/g, "").length == 4;
  });

  $.validator.addMethod("bop_input_year_valid", function (value, element) {
    const inputYear = parseInt(value, 10);
    const currentYear = new Date().getFullYear();
    return !isNaN(inputYear) && inputYear >= 1600 && inputYear <= currentYear;
  });

  $.validator.addMethod("validate_bpp_value", function () {
    return (
      stringToInt($("#value_of_business_personal_property_input").val()) >=
      250001
    );
  });

  $.validator.addMethod("contains_nine_digits", function (value, element) {
    return value.replace(/\D/g, "").length == 9;
  });

  $.validator.addMethod("contains_eight_digits", function (value, element) {
    return value.replace(/\D/g, "").length == 8;
  });

  $.validator.addMethod("contains_ten_digits", function (value, element) {
    return value.replace(/\D/g, "").length == 10;
  });

  $.validator.addMethod("contains_twelve_digits", function (value, element) {
    return value.replace(/\D/g, "").length == 12;
  });

  $.validator.addMethod("hawaii_unemployment_validation", function (value, element) {
    return /^(990|R00|Z00|T00|S00|000)/.test(value) && !/^0{10}$/.test(value) && value.length === 10;
  });

  $.validator.addMethod(
    "contains_three_to_eight_digits",
    function (value, element) {
      return value.length >= 3 && value.length <= 8;
    },
  );

  $.validator.addMethod(
    "contains_eight_to_fifteen_digits",
    function (value, element) {
      return value.length >= 8 && value.length <= 15;
    },
  );

  $.validator.addMethod(
    "must_be_up_to_ten_letters_or_integers",
    function (value, element) {
      return /^[A-Za-z0-9]{1,10}$/.test(value);
    },
  );

  $.validator.addMethod("ssn_must_not_be_invalid", function (value, element) {
    value = value.replace(/\D/g, "");
    let noRepeatingValue = !value.match(/(\d)\1{8}/);
    let noSequencedValue = !value.match("123456789");

    const numInRange = (num, min, max) => {
      return Number(num) >= min && Number(num) <= max;
    };

    let validAreaNumber =
      numInRange(value.slice(0, 3), 1, 665) ||
      numInRange(value.slice(0, 3), 667, 899);
    let validGroupNumber = numInRange(value.slice(3, 5), 1, 99);
    let validSerialNumber = numInRange(value.slice(5), 1, 9999);

    return (
      noRepeatingValue &&
      noSequencedValue &&
      validAreaNumber &&
      validGroupNumber &&
      validSerialNumber
    );
  });

  $.validator.addMethod("fein_must_not_be_invalid", function (value, element) {
    value = value.replace(/\D/g, "");
    let noRepeatingValue = !value.match(/(\d)\1{8}/);
    let noSequencedValue = !value.match("123456789");

    return noRepeatingValue && noSequencedValue;
  });

  $.validator.addMethod("trade_must_be_selected", function (value, element) {
    if ($(element).hasClass("js-ai-trade-search")) {
      return true
    }

    if (!$(element).is(":focus")) {
      const controlBlock = $(element).closest(".control-block.on");
      return (
        controlBlock.hasClass("state-selected") ||
        controlBlock.hasClass("state-blocked")
      );
    } else {
      return true;
    }
  });

  $.validator.addMethod("ai_trade_must_be_selected", function (value, element) {
    if ($(element).hasClass("js-ai-trade-search") && (!$(element).is(":focus")) && value === '') {
      return false;
    }
    return true
  });

  $.validator.addMethod("ai_trade_must_be_selected_with_options", function (value, element) {
    if (!$(element).hasClass("js-ai-trade-search")) {
      return true
    }

    if (!$(element).is(":focus")) {
      const controlBlock = $(element).closest(".control-block.on");
      return (
          controlBlock.hasClass("state-selected") ||
          controlBlock.hasClass("state-blocked")
      );
    } else {
      return true;
    }
  });

  $.validator.addMethod(
    "address_fields_must_be_answered",
    addressFieldsAnsweredValidation,
  );

  $.validator.addMethod("loqate_api_error", loqateApiErrorValidation);

  $.validator.addMethod("validate_not_duplicated_details", function () {
    return contactDetailFields.some(
      (id) => $(`#customer_${id}`).val() !== $(`#buyer_${id}`).val(),
    );
  });

  $(".product-group-title#recommended-products").on("click", function (e) {
    const toggleBlock = $(".tab-content");
    if ($(toggleBlock).is(":visible")) {
      window.EventTracker.trigger(
        "other_coverages_available_section_triggered_event",
        "Other coverages available section closed",
      );
      $(toggleBlock).hide();
      $(".product-group-title#recommended-products").removeClass(
        "opened-tab-content",
      );
    } else {
      window.EventTracker.trigger(
        "other_coverages_available_section_triggered_event",
        "Other coverages available section opened",
      );
      $(toggleBlock).show();
      $(".product-group-title#recommended-products").addClass(
        "opened-tab-content",
      );
    }
  });

  const toggleBlock = $(".additional-covers-content");

  function updateToggleBlockState(state) {
    if (state === 'hidden') {
      $(toggleBlock).hide();
    } else if (state === 'shown') {
      $(toggleBlock).show();
      if (businessQuestionnaire()) {
        $("div[data-question='additional_covers']").hide();
      }
    }
  }

  $('input[name="additional_covers"]').on("change", function() {
    const value = $(this).val();
    const state = value == 'yes' ? 'shown' : 'hidden';
    sessionStorage.setItem('additionalCovers', state);
    updateToggleBlockState(state);
  });

  $(document).ready(function() {
    const additionalCoversValue = $('input[name="additional_covers"]:checked').val();
    const initialState = additionalCoversValue === 'yes' ? 'shown' : 'hidden';
    sessionStorage.setItem('additionalCovers', initialState);

    const storedState = sessionStorage.getItem('additionalCovers');
    updateToggleBlockState(storedState);

    // Fire a Snowplow event when the "Get quotes" button is clicked.
    $("button.get-quotes-button").on("keyup keypress click", function() {
      EventTracker.trigger("clicked_get_quotes_button");
    });
  });

  //The :not(:not logic is necessary to get a teaspoon test to pass
  $('input[type="checkbox"]:not(:not(input[id*="none_of_the_above" i]))').on(
    "change",
    function () {
      var checkboxContainer = this.parentNode.parentNode;
      if (
        checkboxContainer.querySelectorAll("input[type='checkbox']").length ===
          1 &&
        !checkboxContainer.className.includes("control")
      ) {
        checkboxContainer = checkboxContainer.parentNode.parentNode;
      }
      checkboxContainer
        .querySelectorAll(
          "input[type=\"checkbox\"]:not([id*='none_of_the_above' i])",
        )
        .forEach((box) => (box.checked = false));
    },
  );

  $('input[type="checkbox"]:not([id*="none_of_the_above" i])').on(
    "change",
    function () {
      var checkboxContainer = this.parentNode.parentNode;
      if (
        checkboxContainer.querySelectorAll("input[type='checkbox']").length ===
          1 &&
        !checkboxContainer.className.includes("control")
      ) {
        checkboxContainer = checkboxContainer.parentNode.parentNode;
      }
      checkboxContainer
        .querySelectorAll("[id*='none_of_the_above' i]")
        .forEach((box) => (box.checked = false));
    },
  );

  $(".js-trade-list-link").on("click", function (e) {
    const tradeData = $(this).data("trade");

    const urlParams = new URLSearchParams(window.location.search);
    const searchScope = urlParams.get("search_scope");
    const businessUnit = urlParams.get("business_unit");

    const scope =
      searchScope && searchScope.match(/^Coverage(\s|%20)selection$/)
        ? "Coverage selection"
        : searchScope || "journey";

    // Set flag in sessionStorage to indicate we're redirecting from
    // view all trades to prevent duplicate event on next page load
    sessionStorage.setItem("redirectingFromTradeList", "true");

    // Store pre_filled_source in sessionStorage for trade added in coverage selection
    if (
      scope === "Coverage selection" &&
      businessUnit === "simplybusiness_us"
    ) {
      sessionStorage.setItem("preFilledSource", "view_all_trades");
    }

    EventTracker.trigger(
      "primary_detail_selected",
      tradeData,
      true,
      null,
      null,
      businessUnit,
      scope,
      -1
    );
  });

  const tradeSelectorInput = document.querySelector(".trade-search-input");
  const USStateInput = document.querySelector('input[id*="us_state"]');
  const customAutocompleteInputs = [tradeSelectorInput, USStateInput];

  customAutocompleteInputs.forEach((element) => {
    if (element) {
      element.addEventListener("focus", () => {
        element
          .closest('[class*="search-wrapper"]')
          .classList.add("--is-focused");
      });

      element.addEventListener("blur", () => {
        element
          .closest('[class*="search-wrapper"]')
          .classList.remove("--is-focused");
      });
    }
  });

  $('body[data-journey-name="frontoffice_mta"]').on("click", ".fomta_change_address", function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const contactUsText = $(this).next('.change_address_type_error.hidden');
    contactUsText.addClass('error');
  });
})(window.jQuery);
